var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Divider, FormControlLabel, Grid, styled, Switch, Typography, useMediaQuery } from '@mui/material';
import { t } from 'i18next';
import { cloneDeep } from 'lodash';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Get } from '../../../api/api';
import { Config } from '../../../api/config';
import { AlternatePartConfigUrl, AppointmentJobCountUrl, ConfirmAppointmentURL, createSEUrl, DeclinedJobConfigurationSettingURL, DeclinedJobReasonListUrl, EstimateJobCountUrl, getCompleteInspectionUrl, getCustomerDeclinedJobswithPriceUrl, getDeclinedJobCountURL, getSavedJobItemsUrl, getUnitOfMeasurementListUrl, PerodicPartsUrl, precheckDynamicCheckListFormUrl, previousJobCard, previousJobCardURLForRepeat, productAttributeValueUrl, RepairTypeList, RepeatRevisitConfigUrl, VehicleInspectionJobCountUrl, ViewEstimateUrl } from "../../../api/url";
import { ChevronRightIcon } from '../../../assets/customIcons';
import { SuccessIconNew, WarningTriangle } from "../../../assets/images";
import { MuiButton, MuiPopup, MuiStack } from "../../../components";
import CustomeAccordianWithButton from "../../../components/atoms/customAccordianWithButton";
import HeaderDetails from '../../../components/atoms/headerDetails';
import { MuiLoaderButton } from "../../../components/atoms/loaderButton";
import SkeletonLoader from "../../../components/atoms/sketeton";
import UnsavedChangesPopup from "../../../components/molecules/unsavedChangesPopup";
import { EModuleSection, EParentModuleName, ESectionAttributeValue, ESystemName, ETaskName, isModuleConfig, LOCAL_STORAGE_KEYS, Module, StatusEnum } from "../../../constants";
import { setIsTaskDetailsDataUpdated, setTaskDetailsDataSaved, setTaskDetailsToggleValue, setTasksDetailsIsDisable, setUpdatedModuleSectionByChannel, showLoader, showNotification } from "../../../redux/commonSlice";
import { createAPI, getByIdAPI, getListAPI, resetState, setState, updateAPI } from "../../../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { systemColor } from '../../../theme/systemColor';
import { getLocalStorageItem, setLocalStorageItem } from "../../../utils/storageHelper";
import useAnalyticsEventTracker from '../../../utils/useAnalyticsEventTracker';
import { dateFormate, getAlternatePartConfigByTaskName, getTime, GoogleAnlyticsErrorLog, scrollToTop, transactionEventLog } from "../../../utils/utils";
import FutureAdviseGrid from '../../futureAdvise/FutureAdviseGrid';
import OptionAlert from '../../jobCard/repeat/optionsAlert';
import PreviousDeclinedJob from "./previousDeclinedJob";
import AdditionalJobsComponent from "./taskDetailsCommonComponent/additionalJob/additionalJobComponent";
import AdvisorSuggestions from './taskDetailsCommonComponent/AdvisorSuggestions';
import PeriodicMaintainanceComponent from './taskDetailsCommonComponent/periodicMaintainanceComponent';
import PreCheckCommonComponent from "./taskDetailsCommonComponent/preCheckCommonComponent";
import RoadTestComponent from "./taskDetailsCommonComponent/roadTestComponent";
import StandaredJobsComponent from "./taskDetailsCommonComponent/standaredJobs";
var IOSSwitch = styled(function (props) { /*#__PURE__*/ return React.createElement(Switch, _extends({
    focusVisibleClassName: ".Mui-focusVisible",
    disableRipple: true
}, props)); })(function (_ref) {
    var theme = _ref.theme;
    return {
        width: 42,
        height: 26,
        padding: 0,
        "& .MuiSwitch-switchBase": {
            padding: 0,
            margin: 2,
            transitionDuration: "300ms",
            "&.Mui-checked": {
                transform: "translateX(16px)",
                color: "#fff",
                "& + .MuiSwitch-track": {
                    backgroundColor: theme.palette.mode === "dark" ? systemColor.primary : systemColor.primary,
                    opacity: 1,
                    border: 0
                },
                "&.Mui-disabled + .MuiSwitch-track": {
                    opacity: 0.5
                }
            },
            "&.Mui-focusVisible .MuiSwitch-thumb": {
                color: "#33cf4d",
                border: "6px solid #fff"
            },
            "&.Mui-disabled .MuiSwitch-thumb": {
                color: theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600]
            },
            "&.Mui-disabled + .MuiSwitch-track": {
                opacity: theme.palette.mode === "light" ? 0.7 : 0.3
            }
        },
        "& .MuiSwitch-thumb": {
            boxSizing: "border-box",
            width: 22,
            height: 22
        },
        "& .MuiSwitch-track": {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
            opacity: 1,
            transition: theme.transitions.create(["background-color"], {
                duration: 500
            })
        }
    };
});
var MyImg = styled("img")(function (_ref2) {
    var theme = _ref2.theme;
    return {
        height: "48px",
        marginRight: "5px",
        width: "48px"
    };
});
var TaskDetailsComponent = function (props) {
    var _ModuleDetailsGetById35, _ModuleDetailsGetById36, _ModuleDetailsGetById37, _ModuleDetailsGetById38, _ModuleDetailsGetById39, _ModuleDetailsGetById40, _ModuleDetailsGetById41, _ModuleDetailsGetById42, _ModuleDetailsGetById43, _ModuleDetailsGetById44, _ModuleDetailsGetById45, _ModuleDetailsGetById46, _ModuleDetailsGetById47, _documentDetailsGetBy3, _documentDetailsGetBy4, _documentDetailsGetBy5, _documentDetailsGetBy6, _documentDetailsGetBy7, _documentDetailsGetBy8, _previousJobCards$dat2;
    var trackButtonClick = useAnalyticsEventTracker("TaskDetailsComponent");
    var profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
    var parentModuleName = props.parentModuleName, _a = props.isSaveButton, isSaveButton = _a === void 0 ? true : _a, createAndEditFlow = props.createAndEditFlow, documentId = props.documentId, parentModuleDocumentId = props.parentModuleDocumentId, getSavedPeriodicPartsUrl = props.getSavedPeriodicPartsUrl;
    var skeletonArray = Array.from({
        length: 4
    });
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var inspectionId = useParams().inspectionId;
    var _b = useSelector(function (state) { return state.common; }), updatedModuleSectionByChannel = _b.updatedModuleSectionByChannel, getSavedTaskDetailsCount = _b.getSavedTaskDetailsCount, tasksDetailsIsDisable = _b.tasksDetailsIsDisable, getTaskDetailsToggleValue = _b.getTaskDetailsToggleValue, isTaskDetailDataUpdated = _b.isTaskDetailDataUpdated, taskDetailDataSaved = _b.taskDetailDataSaved, isFuelIndicatorSliderChanged = _b.isFuelIndicatorSliderChanged;
    var _c = useSelector(function (state) { return state.crud; }), ModuleDetailsGetById = _c.ModuleDetailsGetById, getModuleHeaderCount = _c.getModuleHeaderCount, documentDetailsGetById = _c.documentDetailsGetById, TaskDetailsSectionSave = _c.TaskDetailsSectionSave, fuelIndicatorSaved = _c.fuelIndicatorSaved, savedSuggestions = _c.savedSuggestions, savedFutureAdvice = _c.savedFutureAdvice;
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var _d = useState(false), allswitchEnabled = _d[0], setAllSwitchEnabled = _d[1];
    var _e = React.useState(false), callApi = _e[0], setCallApi = _e[1];
    var _f = useState(true), addiotionalJobApiCall = _f[0], setAddiotionalJobApiCall = _f[1];
    var _g = useState(true), precheckApiCall = _g[0], setPrecheckApiCall = _g[1];
    var _h = useState(true), roadTestApiCall = _h[0], setRoadTestApiCall = _h[1];
    var _j = useState(true), periodicMaintainanceApiCall = _j[0], setPeriodicMaintainanceApiCall = _j[1];
    var _k = useState(false), openPopup = _k[0], setOpenPopup = _k[1];
    var _l = useState(false), finishPopup = _l[0], setFinishPopup = _l[1];
    var _m = useState(false), openAptcreatePopup = _m[0], setOpenAptcreatePopup = _m[1];
    var _o = useState({}), jobCount = _o[0], setJobCount = _o[1];
    var _p = useState(false), additionalJobAdded = _p[0], setAdditionalJobAdded = _p[1];
    var _q = useState([]), fuelIdicatorDynamicListTaskDetails = _q[0], setFuelIndicatorDynamicListTaskDetails = _q[1];
    var _r = useState([]), pmPartsMasterList = _r[0], setPmPartsMasterList = _r[1];
    var _s = useState(true), isSkeleton = _s[0], setIsSkeleton = _s[1];
    // const allFuleIndicatorValuesEmpty =  
    //   fuelIdicatorDynamicListTaskDetails.length > 0
    //     ? fuelIdicatorDynamicListTaskDetails[0].Questions?.every(
    //       (item) => item.ResponseValue === ""
    //     )
    //     : false;
    var checkAllFuelIndicatorValuesEmpty = function () {
        var _fuelIdicatorDynamicL;
        return fuelIdicatorDynamicListTaskDetails.length > 0 ? (_fuelIdicatorDynamicL = fuelIdicatorDynamicListTaskDetails[0].Questions) === null || _fuelIdicatorDynamicL === void 0 ? void 0 : _fuelIdicatorDynamicL.some(function (item) { return item.ResponseValue === ""; }) : false;
    };
    var _t = useState([]), productWisePmsList = _t[0], setProductWisePmsList = _t[1];
    var _u = useState(false), isExpanded = _u[0], setIsExpanded = _u[1];
    var _v = useState({
        "Additional Jobs": true,
        "Customer Voice": true,
        "Periodic Maintenance": true,
        "Standard Services": true
    }), alternatePartConfigState = _v[0], setAlternatePartConfigState = _v[1];
    var _w = useState(false), expanded = _w[0], setExpanded = _w[1];
    var contentRef = useRef(null);
    var _x = useState(0), contentHeight = _x[0], setContentHeight = _x[1];
    var _y = useState(false), openPreviousDeclinePopup = _y[0], setOpenPreviousDeclinePopup = _y[1];
    var byChannelId = getLocalStorageItem("ByChannelId");
    var _z = useState(false), renderPreviousDeclineJob = _z[0], setRenderPreviousDeclineJob = _z[1]; //TO DISPLAY PREVIOUS DECLINE JOB BUTTON
    var isDesktop = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var isTablet = useMediaQuery("(min-width:900px)and (max-width:1350px)");
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var _0 = useState(null), declinedJobsConfiguration = _0[0], setDeclinedJobsConfiguration = _0[1];
    var _1 = useState(null), previousJobCards = _1[0], setPreviousJobCards = _1[1];
    var _2 = useState(false), previousDeclinedLoader = _2[0], setPreviousDeclinedLoader = _2[1];
    var _3 = useState(null), previousJobcardRepeat = _3[0], setPreviousJobcardRepeat = _3[1];
    var _4 = useState([]), rejectReasonRemarkList = _4[0], setRejectReasonRemarkList = _4[1];
    var _5 = useState([]), declinedPmPartsList = _5[0], setDeclinedPmPartsList = _5[1];
    var _6 = useState([]), pmPartsList = _6[0], setpmPartsList = _6[1];
    var _7 = useState(false), showRepeatAlertsPopup = _7[0], setShowRepeatAlertsPopup = _7[1];
    var _8 = useState([]), repeatJobItems = _8[0], setRepeatJobItemsDetails = _8[1];
    var _9 = useState(null), precheckQuestionsAnswer = _9[0], setPrecheckQuestionsAnswer = _9[1];
    var getAdditonalJobCallbackButtonDisable = function (data) {
        setAdditionalJobAdded(data);
    };
    var getRejectRemarkList = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        Get(DeclinedJobReasonListUrl).then(function (response) {
                            if (response.success && response.data) {
                                setRejectReasonRemarkList(response.data);
                            }
                            resolve(response);
                        }).catch(function (getRejectRemarkListError) {
                            reject(getRejectRemarkListError);
                        });
                        return [2 /*return*/];
                    });
                }); })];
        });
    }); };
    var initiate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, Promise.all([getRejectRemarkList(), getProductWisePmParts()])];
                case 1:
                    _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    console.log("error : initiate in PeriodicMaintainanceComponent", error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        dispatch(setState({
            key: "TaskDetailsSectionSave",
            value: {}
        }));
        dispatch(setState({
            key: "fuelIndicatorSaved",
            value: false
        }));
        dispatch(setState({
            key: "preDocumentFetch",
            value: []
        }));
        getRepeatResonConfig();
    }, []);
    useEffect(function () {
        scrollToTop();
        // setTimeout(() => {
        getInitialData();
        // }, 500);
    }, [getTaskDetailsToggleValue]);
    useEffect(function () {
        getDisabled();
    }, [tasksDetailsIsDisable, getSavedTaskDetailsCount, updatedModuleSectionByChannel, getTaskDetailsToggleValue, allswitchEnabled]);
    var SetPrevDeclineConfig = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _declinedJobsConfigur, IsDeclinedJobCardToShow, _declinedJobsConfigur2, _declinedJobsConfigur3, _declinedJobsConfigur4, _previousJobCards$dat, data, NumberOfDeclinedJobCardDays, NumberOfDeclinedJobCardToShow, previousJobCards_1, isOpenPopup, updatedList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    IsDeclinedJobCardToShow = declinedJobsConfiguration === null || declinedJobsConfiguration === void 0 || (_declinedJobsConfigur = declinedJobsConfiguration.UISettings) === null || _declinedJobsConfigur === void 0 ? void 0 : _declinedJobsConfigur.find(function (item) { return item.Key === "IsDeclinedJobCardToShow"; });
                    if (!(ModuleDetailsGetById !== null && ModuleDetailsGetById !== void 0 && ModuleDetailsGetById.data)) return [3 /*break*/, 2];
                    data = (IsDeclinedJobCardToShow === null || IsDeclinedJobCardToShow === void 0 ? void 0 : IsDeclinedJobCardToShow.Value) === "true";
                    NumberOfDeclinedJobCardDays = declinedJobsConfiguration === null || declinedJobsConfiguration === void 0 || (_declinedJobsConfigur2 = declinedJobsConfiguration.UISettings) === null || _declinedJobsConfigur2 === void 0 ? void 0 : _declinedJobsConfigur2.find(function (item) { return item.Key === "NumberOfDeclinedJobCardDays"; });
                    NumberOfDeclinedJobCardToShow = declinedJobsConfiguration === null || declinedJobsConfiguration === void 0 || (_declinedJobsConfigur3 = declinedJobsConfiguration.UISettings) === null || _declinedJobsConfigur3 === void 0 ? void 0 : _declinedJobsConfigur3.find(function (item) { return item.Key === "NumberOfDeclinedJobCardToShow"; });
                    // if (data) {
                    setRenderPreviousDeclineJob(true);
                    return [4 /*yield*/, getPreviousDeclinedJobsAPI(NumberOfDeclinedJobCardDays, NumberOfDeclinedJobCardToShow)];
                case 1:
                    previousJobCards_1 = _a.sent();
                    isOpenPopup = declinedJobsConfiguration === null || declinedJobsConfiguration === void 0 || (_declinedJobsConfigur4 = declinedJobsConfiguration.UISettings) === null || _declinedJobsConfigur4 === void 0 ? void 0 : _declinedJobsConfigur4.find(function (item) { return item.Key === "IsDeclinedJobCardToShowInPopup"; });
                    if (((isOpenPopup === null || isOpenPopup === void 0 ? void 0 : isOpenPopup.Value) === "true" || (isOpenPopup === null || isOpenPopup === void 0 ? void 0 : isOpenPopup.Value) === true) && !props.isDisabled && previousJobCards_1 !== null && previousJobCards_1 !== void 0 && previousJobCards_1.success && (previousJobCards_1 === null || previousJobCards_1 === void 0 || (_previousJobCards$dat = previousJobCards_1.data) === null || _previousJobCards$dat === void 0 ? void 0 : _previousJobCards$dat.length) > 0 && (previousJobCards_1 === null || previousJobCards_1 === void 0 ? void 0 : previousJobCards_1.DeclinedTotalCount) > 0) {
                        setPeriodicMaintainanceApiCall(false);
                        setAddiotionalJobApiCall(false);
                        setPrecheckApiCall(false);
                        setRoadTestApiCall(false);
                        setCallApi(false);
                        if (updatedModuleSectionByChannel && updatedModuleSectionByChannel.length > 0) {
                            updatedList = updatedModuleSectionByChannel === null || updatedModuleSectionByChannel === void 0 ? void 0 : updatedModuleSectionByChannel.map(function (item) {
                                return _objectSpread(_objectSpread({}, item), {}, {
                                    isAccordianOpen: false
                                });
                            });
                            dispatch(setUpdatedModuleSectionByChannel(updatedList));
                        }
                        setOpenPreviousDeclinePopup(true);
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var _declinedJobsConfigur5;
        if ((declinedJobsConfiguration === null || declinedJobsConfiguration === void 0 || (_declinedJobsConfigur5 = declinedJobsConfiguration.UISettings) === null || _declinedJobsConfigur5 === void 0 ? void 0 : _declinedJobsConfigur5.length) > 0) {
            SetPrevDeclineConfig();
        }
    }, [
        // updatedModuleSectionByChannel,
        declinedJobsConfiguration, ModuleDetailsGetById
    ]);
    useEffect(function () {
        var _declinedJobsConfigur6;
        if (ModuleDetailsGetById !== null && ModuleDetailsGetById !== void 0 && ModuleDetailsGetById.data) {
            var _ModuleDetailsGetById, _ModuleDetailsGetById2, _ModuleDetailsGetById3, _pmsSetting$SectionAt;
            if (!(props.parentModuleName === EParentModuleName.Appointment || props.parentModuleName === EParentModuleName.finalInspector)) {
                getFuelLevel();
            }
            getServiceTypesList();
            getCountModuleWise(jobCount);
            getUOMList();
            // getProductWisePmParts();
            getDeclineJobConfig();
            getAlternatePartConfig();
            var previousJobcardBody = {
                InstallBaseId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById === void 0 ? void 0 : _ModuleDetailsGetById.InstallBaseId,
                Status: ModuleDetailsGetById !== null && ModuleDetailsGetById !== void 0 && (_ModuleDetailsGetById2 = ModuleDetailsGetById.data) !== null && _ModuleDetailsGetById2 !== void 0 && _ModuleDetailsGetById2.Key ? ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById3 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById3 === void 0 ? void 0 : _ModuleDetailsGetById3.Key : null
            };
            dispatch(createAPI({
                key: "previousJobCards",
                url: previousJobCardURLForRepeat,
                request: previousJobcardBody
            })).then(function (result) {
                var previousJcItem = result && result.payload && result.payload.value && result.payload.value.success && result.payload.value.data && Array.isArray(result.payload.value.data) && result.payload.value.data[0] ? result.payload.value.data[0] : null;
                setPreviousJobcardRepeat(previousJcItem);
            });
            var pmsSetting = updatedModuleSectionByChannel === null || updatedModuleSectionByChannel === void 0 ? void 0 : updatedModuleSectionByChannel.find(function (item) { return (item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.PeriodicMaintenance; });
            // pmsSetting.
            if ((pmsSetting === null || pmsSetting === void 0 ? void 0 : pmsSetting.SectionAttributes.length) > 0 && !(pmsSetting !== null && pmsSetting !== void 0 && (_pmsSetting$SectionAt = pmsSetting.SectionAttributes[0]) !== null && _pmsSetting$SectionAt !== void 0 && _pmsSetting$SectionAt.HIDE)) {
                initiate();
            }
        }
        var IsDeclinedJobCardToShow = declinedJobsConfiguration === null || declinedJobsConfiguration === void 0 || (_declinedJobsConfigur6 = declinedJobsConfiguration.UISettings) === null || _declinedJobsConfigur6 === void 0 ? void 0 : _declinedJobsConfigur6.find(function (item) { return item.Key === "IsDeclinedJobCardToShow"; });
    }, [ModuleDetailsGetById]);
    useEffect(function () {
        if (contentRef !== null && contentRef !== void 0 && contentRef.current && isExpanded) {
            setTimeout(function () {
                var _contentRef$current;
                setContentHeight(contentRef === null || contentRef === void 0 || (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.offsetHeight);
            }, 200);
        }
        else {
            setContentHeight("100vh");
        }
    }, [expanded]);
    var getUOMList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _ModuleDetailsGetById4, request, _ModuleDetailsGetById5, UOMList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        ModuleEntityId: props.SystemName,
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    if (ModuleDetailsGetById !== null && ModuleDetailsGetById !== void 0 && (_ModuleDetailsGetById4 = ModuleDetailsGetById.data) !== null && _ModuleDetailsGetById4 !== void 0 && _ModuleDetailsGetById4.ProductId) {
                        request.ProductId = ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById5 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById5 === void 0 ? void 0 : _ModuleDetailsGetById5.ProductId;
                    }
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "UOMList",
                            url: getUnitOfMeasurementListUrl
                        }))];
                case 1:
                    UOMList = _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var getServiceTypesList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _ModuleDetailsGetById6, _repairType$payload, _repairType$payload2, request, _ModuleDetailsGetById7, repairType, _repairType$payload3, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    request = {
                        ModuleEntityId: props.SystemName,
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    if (ModuleDetailsGetById !== null && ModuleDetailsGetById !== void 0 && (_ModuleDetailsGetById6 = ModuleDetailsGetById.data) !== null && _ModuleDetailsGetById6 !== void 0 && _ModuleDetailsGetById6.ProductId) {
                        request.ProductId = ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById7 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById7 === void 0 ? void 0 : _ModuleDetailsGetById7.ProductId;
                    }
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "serviceTypeList",
                            url: RepairTypeList,
                            request: request
                        }))];
                case 1:
                    repairType = _a.sent();
                    if ((repairType === null || repairType === void 0 || (_repairType$payload = repairType.payload) === null || _repairType$payload === void 0 || (_repairType$payload = _repairType$payload.value) === null || _repairType$payload === void 0 ? void 0 : _repairType$payload.statusCode) == 200 || repairType !== null && repairType !== void 0 && (_repairType$payload2 = repairType.payload) !== null && _repairType$payload2 !== void 0 && (_repairType$payload2 = _repairType$payload2.value) !== null && _repairType$payload2 !== void 0 && _repairType$payload2.success) {
                        return [2 /*return*/, repairType === null || repairType === void 0 || (_repairType$payload3 = repairType.payload) === null || _repairType$payload3 === void 0 || (_repairType$payload3 = _repairType$payload3.value) === null || _repairType$payload3 === void 0 ? void 0 : _repairType$payload3.data];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    console.error("Error fetching repair types:", e_1);
                    return [2 /*return*/, []];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getRepeatResonConfig = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: 
                // await dispatch(showSurface({
                //   type: 'Dialog',
                //   containerProps: {
                //     fullWidth: true,
                //     PaperProps: {
                //       sx: {
                //         borderRadius: '12px',
                //         // width: {
                //         //   sm: '350px',
                //         //   md: '450px',
                //         //   lg: '450px',
                //         // }
                //       }
                //     }
                //   },
                //   Component: FutureAdvicePopup,
                //   componentProps: { onClose: () => { } }
                // }))
                return [4 /*yield*/, dispatch(getListAPI({
                        key: 'repeatAlertConfiguration',
                        url: RepeatRevisitConfigUrl,
                        request: {
                            OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                        }
                    }))];
                case 1:
                    // await dispatch(showSurface({
                    //   type: 'Dialog',
                    //   containerProps: {
                    //     fullWidth: true,
                    //     PaperProps: {
                    //       sx: {
                    //         borderRadius: '12px',
                    //         // width: {
                    //         //   sm: '350px',
                    //         //   md: '450px',
                    //         //   lg: '450px',
                    //         // }
                    //       }
                    //     }
                    //   },
                    //   Component: FutureAdvicePopup,
                    //   componentProps: { onClose: () => { } }
                    // }))
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var getDeclinedCountsByJcId = function (jcList) { return __awaiter(void 0, void 0, void 0, function () {
        var jobcountPromiseArray, result, _loop_1, _i, jcList_1, jcListItem, jobCountsArray, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    jobcountPromiseArray = [];
                    result = [];
                    _loop_1 = function (jcListItem) {
                        var jobItemPromiseItem = new Promise(function (resolve, reject) {
                            dispatch(createAPI({
                                url: getDeclinedJobCountURL,
                                request: {
                                    ParentId: jcListItem.id,
                                    Entity: props.SystemName
                                }
                            })).then(function (result) {
                                var jobCounts = {
                                    AdditionalJobs: 0,
                                    StandardJobs: 0,
                                    PeriodicParts: 0,
                                    CustomerComplaints: 0,
                                    Id: jcListItem.id
                                };
                                if (result && result.payload && result.payload.success && result.payload.data) {
                                    jobCounts = _objectSpread(_objectSpread({}, result.payload.data), {}, {
                                        Id: jcListItem.id
                                    });
                                }
                                resolve(jobCounts);
                            }).catch(function (err) {
                                reject(err);
                            });
                        });
                        jobcountPromiseArray.push(jobItemPromiseItem);
                    };
                    for (_i = 0, jcList_1 = jcList; _i < jcList_1.length; _i++) {
                        jcListItem = jcList_1[_i];
                        _loop_1(jcListItem);
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Promise.all(jobcountPromiseArray)];
                case 2:
                    jobCountsArray = _a.sent();
                    result = jobCountsArray.filter(function (jobItem) { return jobItem.PeriodicParts || jobItem.StandardJobs || jobItem.CustomerComplaints || jobItem.AdditionalJobs; }).map(function (item) { return String(item.Id); });
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, result];
            }
        });
    }); };
    var getDeclineJobConfig = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload, _result$payload2, request, _ModuleDetailsGetById8, result, _result$payload3, _result$payload4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        OrganizationId: selectedBranch.OrganizationId
                    };
                    if (props.parentModuleName === EParentModuleName.Appointment) {
                        request.SystemName = ESystemName.Appointment;
                    }
                    else if (props.parentModuleName === EParentModuleName.ServiceEstimate) {
                        if ((ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById8 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById8 === void 0 ? void 0 : _ModuleDetailsGetById8.EstimateType) === "RevisedEstimate") {
                            request.SystemName = ESystemName.RevisedEstimate;
                        }
                        else {
                            request.SystemName = ESystemName.Estimate;
                        }
                    }
                    else if (props.parentModuleName === EParentModuleName.Inspection) {
                        request.SystemName = ESystemName.Inspection;
                    }
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "declinedJobConfiguration",
                            url: DeclinedJobConfigurationSettingURL,
                            request: request
                        }))];
                case 1:
                    result = _a.sent();
                    if (result !== null && result !== void 0 && (_result$payload = result.payload) !== null && _result$payload !== void 0 && (_result$payload = _result$payload.value) !== null && _result$payload !== void 0 && _result$payload.success && result !== null && result !== void 0 && (_result$payload2 = result.payload) !== null && _result$payload2 !== void 0 && (_result$payload2 = _result$payload2.value) !== null && _result$payload2 !== void 0 && _result$payload2.data) {
                        setDeclinedJobsConfiguration(result === null || result === void 0 || (_result$payload3 = result.payload) === null || _result$payload3 === void 0 || (_result$payload3 = _result$payload3.value) === null || _result$payload3 === void 0 ? void 0 : _result$payload3.data);
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.DECLINED_JOB_CONFIGURATION, result === null || result === void 0 || (_result$payload4 = result.payload) === null || _result$payload4 === void 0 || (_result$payload4 = _result$payload4.value) === null || _result$payload4 === void 0 ? void 0 : _result$payload4.data);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getProductWisePmParts = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _ModuleDetailsGetById9, _ModuleDetailsGetById10, _ModuleDetailsGetById11, _ModuleDetailsGetById12, _ModuleDetailsGetById13, _ModuleDetailsGetById14, _ModuleDetailsGetById15, _ModuleDetailsGetById18, _ModuleDetailsGetById19, _ModuleDetailsGetById20, _ModuleDetailsGetById21, _SavedPmPartsResponse, _SavedPmPartsResponse2, requestBody, request, _ModuleDetailsGetById16, _ModuleDetailsGetById17, declineJobRequestBody, _a, response, SavedPmPartsResponse, declinedPmPartsResponse, savedPmPartsList, _SavedPmPartsResponse3, _SavedPmPartsResponse4, _response$payload$val, _response$payload$val2, _declinedPmPartsRespo, _declinedPmPartsRespo2, masterPmPartsList_1, _declinedPmPartsRespo3, _declinedPmPartsRespo4, _declinedPmPartsRespo5, _declinedPmPartsRespo6, declinedParts, declinedLabours, declinesPmParts_1, finalList_1, PmTotalPrice_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    requestBody = {
                        "Usage": Number(ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById9 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById9 === void 0 ? void 0 : _ModuleDetailsGetById9.ODOMeterReading),
                        "VinNo": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById10 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById10 === void 0 ? void 0 : _ModuleDetailsGetById10.VinNo,
                        "InstallBaseId": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById11 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById11 === void 0 ? void 0 : _ModuleDetailsGetById11.InstallBaseId,
                        "RepairTypeId": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById12 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById12 === void 0 ? void 0 : _ModuleDetailsGetById12.RepairTypeId,
                        "OrganizationId": selectedBranch.OrganizationId,
                        "PreJobCardDocumentId": documentId,
                        "Entity": props.SystemName
                    };
                    request = {
                        RepairTypeId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById13 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById13 === void 0 ? void 0 : _ModuleDetailsGetById13.RepairTypeId,
                        OrganizationId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById14 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById14 === void 0 ? void 0 : _ModuleDetailsGetById14.OrganizationId,
                        VinNo: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById15 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById15 === void 0 ? void 0 : _ModuleDetailsGetById15.VinNo
                    };
                    if (parentModuleName === EParentModuleName.Appointment) {
                        request.AppointmentId = parentModuleDocumentId;
                    }
                    if (parentModuleName === EParentModuleName.ServiceEstimate) {
                        request.EstimateId = parentModuleDocumentId;
                        request.VinNo = ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById16 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById16 === void 0 ? void 0 : _ModuleDetailsGetById16.VinNo;
                        request.OrganizationId = selectedBranch.OrganizationId;
                    }
                    if (parentModuleName === EParentModuleName.Inspection) {
                        request.InspectionId = parentModuleDocumentId;
                        request.VinNo = ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById17 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById17 === void 0 ? void 0 : _ModuleDetailsGetById17.VinNo;
                        request.OrganizationId = selectedBranch.OrganizationId;
                    }
                    declineJobRequestBody = {
                        "ParentId": parentModuleDocumentId,
                        "InstallBaseId": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById18 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById18 === void 0 ? void 0 : _ModuleDetailsGetById18.InstallBaseId,
                        "ServiceDetailType": 3,
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        VinNo: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById19 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById19 === void 0 ? void 0 : _ModuleDetailsGetById19.VinNo,
                        ServiceTypeId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById20 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById20 === void 0 ? void 0 : _ModuleDetailsGetById20.RepairTypeId,
                        Entity: props.SystemName,
                        PreJobCardDocumentId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById21 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById21 === void 0 ? void 0 : _ModuleDetailsGetById21.id
                    };
                    return [4 /*yield*/, Promise.all([dispatch(getListAPI({
                                key: "",
                                url: PerodicPartsUrl,
                                request: requestBody
                            })), dispatch(getByIdAPI({
                                key: "",
                                url: getSavedPeriodicPartsUrl,
                                request: request
                            })), dispatch(getListAPI({
                                key: "",
                                url: getCustomerDeclinedJobswithPriceUrl,
                                request: declineJobRequestBody
                            }))])];
                case 1:
                    _a = _b.sent(), response = _a[0], SavedPmPartsResponse = _a[1], declinedPmPartsResponse = _a[2];
                    savedPmPartsList = [];
                    if (SavedPmPartsResponse.payload.success && ((_SavedPmPartsResponse = SavedPmPartsResponse.payload.data) === null || _SavedPmPartsResponse === void 0 || (_SavedPmPartsResponse = _SavedPmPartsResponse.PeriodicParts) === null || _SavedPmPartsResponse === void 0 || (_SavedPmPartsResponse = _SavedPmPartsResponse.Labour) === null || _SavedPmPartsResponse === void 0 ? void 0 : _SavedPmPartsResponse.length) > 0 || ((_SavedPmPartsResponse2 = SavedPmPartsResponse.payload.data) === null || _SavedPmPartsResponse2 === void 0 || (_SavedPmPartsResponse2 = _SavedPmPartsResponse2.PeriodicParts) === null || _SavedPmPartsResponse2 === void 0 || (_SavedPmPartsResponse2 = _SavedPmPartsResponse2.Part) === null || _SavedPmPartsResponse2 === void 0 ? void 0 : _SavedPmPartsResponse2.length) > 0) {
                        SavedPmPartsResponse === null || SavedPmPartsResponse === void 0 || (_SavedPmPartsResponse3 = SavedPmPartsResponse.payload) === null || _SavedPmPartsResponse3 === void 0 || (_SavedPmPartsResponse3 = _SavedPmPartsResponse3.data) === null || _SavedPmPartsResponse3 === void 0 || (_SavedPmPartsResponse3 = _SavedPmPartsResponse3.PeriodicParts) === null || _SavedPmPartsResponse3 === void 0 || _SavedPmPartsResponse3.Labour.map(function (item) {
                            var updatedItem = _objectSpread({}, item);
                            updatedItem.jobType = "Labour";
                            updatedItem.isExpanded = false;
                            savedPmPartsList.push(updatedItem);
                        });
                        SavedPmPartsResponse === null || SavedPmPartsResponse === void 0 || (_SavedPmPartsResponse4 = SavedPmPartsResponse.payload) === null || _SavedPmPartsResponse4 === void 0 || (_SavedPmPartsResponse4 = _SavedPmPartsResponse4.data) === null || _SavedPmPartsResponse4 === void 0 || (_SavedPmPartsResponse4 = _SavedPmPartsResponse4.PeriodicParts) === null || _SavedPmPartsResponse4 === void 0 || _SavedPmPartsResponse4.Part.map(function (item) {
                            var updatedItem = _objectSpread({}, item);
                            updatedItem.jobType = "Part";
                            updatedItem.isExpanded = false;
                            savedPmPartsList.push(updatedItem);
                        });
                    }
                    else {
                        setIsSkeleton(false);
                    }
                    if (response.payload.value.success && response.payload.value.data) {
                        masterPmPartsList_1 = [];
                        (_response$payload$val = response.payload.value.data) === null || _response$payload$val === void 0 || _response$payload$val.Labour.map(function (item) {
                            var updatedItem = _objectSpread({}, item);
                            updatedItem.jobType = "Labour";
                            updatedItem.isExpanded = false;
                            masterPmPartsList_1.push(updatedItem);
                        });
                        (_response$payload$val2 = response.payload.value.data) === null || _response$payload$val2 === void 0 || _response$payload$val2.Part.map(function (item) {
                            var updatedItem = _objectSpread({}, item);
                            updatedItem.jobType = "Part";
                            updatedItem.isExpanded = false;
                            masterPmPartsList_1.push(updatedItem);
                        });
                        setPmPartsMasterList(masterPmPartsList_1);
                        setProductWisePmsList(masterPmPartsList_1);
                        if ((_declinedPmPartsRespo = declinedPmPartsResponse.payload) !== null && _declinedPmPartsRespo !== void 0 && (_declinedPmPartsRespo = _declinedPmPartsRespo.value) !== null && _declinedPmPartsRespo !== void 0 && _declinedPmPartsRespo.success && (_declinedPmPartsRespo2 = declinedPmPartsResponse.payload) !== null && _declinedPmPartsRespo2 !== void 0 && (_declinedPmPartsRespo2 = _declinedPmPartsRespo2.value) !== null && _declinedPmPartsRespo2 !== void 0 && _declinedPmPartsRespo2.data) {
                            declinedParts = (_declinedPmPartsRespo3 = declinedPmPartsResponse.payload) !== null && _declinedPmPartsRespo3 !== void 0 && (_declinedPmPartsRespo3 = _declinedPmPartsRespo3.value) !== null && _declinedPmPartsRespo3 !== void 0 && (_declinedPmPartsRespo3 = _declinedPmPartsRespo3.data) !== null && _declinedPmPartsRespo3 !== void 0 && _declinedPmPartsRespo3.Part ? (_declinedPmPartsRespo4 = declinedPmPartsResponse.payload) === null || _declinedPmPartsRespo4 === void 0 || (_declinedPmPartsRespo4 = _declinedPmPartsRespo4.value) === null || _declinedPmPartsRespo4 === void 0 || (_declinedPmPartsRespo4 = _declinedPmPartsRespo4.data) === null || _declinedPmPartsRespo4 === void 0 ? void 0 : _declinedPmPartsRespo4.Part : [];
                            declinedLabours = (_declinedPmPartsRespo5 = declinedPmPartsResponse.payload) !== null && _declinedPmPartsRespo5 !== void 0 && (_declinedPmPartsRespo5 = _declinedPmPartsRespo5.value) !== null && _declinedPmPartsRespo5 !== void 0 && (_declinedPmPartsRespo5 = _declinedPmPartsRespo5.data) !== null && _declinedPmPartsRespo5 !== void 0 && _declinedPmPartsRespo5.Labour ? (_declinedPmPartsRespo6 = declinedPmPartsResponse.payload) === null || _declinedPmPartsRespo6 === void 0 || (_declinedPmPartsRespo6 = _declinedPmPartsRespo6.value) === null || _declinedPmPartsRespo6 === void 0 || (_declinedPmPartsRespo6 = _declinedPmPartsRespo6.data) === null || _declinedPmPartsRespo6 === void 0 ? void 0 : _declinedPmPartsRespo6.Labour : [];
                            declinesPmParts_1 = __spreadArray(__spreadArray([], declinedParts, true), declinedLabours, true);
                            setDeclinedPmPartsList(declinesPmParts_1);
                            finalList_1 = [];
                            masterPmPartsList_1.map(function (masterItem) {
                                var isSaved = savedPmPartsList.find(function (savedItem) { return savedItem.ChildId === masterItem.ChildId; });
                                var isDeclined = declinesPmParts_1.find(function (declinedItem) { return declinedItem.ChildId === masterItem.ChildId; });
                                if (isSaved) {
                                    var _isSaved$Price;
                                    var findMRPObject = masterItem.Price.find(function (item) { return item.MRP === isSaved.Price.MRP; });
                                    var updatedItem = _objectSpread({}, isSaved);
                                    updatedItem.isExpanded = false;
                                    updatedItem.Quantity = (_isSaved$Price = isSaved.Price) === null || _isSaved$Price === void 0 ? void 0 : _isSaved$Price.Quantity;
                                    updatedItem.jobType = masterItem.jobType;
                                    updatedItem.PartName = masterItem.jobType === "Part" ? masterItem.PartName : "";
                                    updatedItem.LabourName = masterItem.jobType === "Labour" ? masterItem.LabourName : "";
                                    // updatedItem.Price = Number((Number(masterItem?.Price ?? 0) * Number(masterItem?.Quantity)).toFixed(2))
                                    updatedItem.Price = masterItem.Price;
                                    updatedItem.LabourCode = masterItem.jobType === "Labour" ? masterItem.LabourCode : "";
                                    updatedItem.PartCode = masterItem.jobType === "Part" ? masterItem.PartCode : "";
                                    updatedItem.SelectedPriceDetails = _objectSpread(_objectSpread({}, isSaved.Price), {}, {
                                        MaxPrice: findMRPObject === null || findMRPObject === void 0 ? void 0 : findMRPObject.MaxPrice,
                                        MinPrice: findMRPObject === null || findMRPObject === void 0 ? void 0 : findMRPObject.MinPrice,
                                        EditableRange: findMRPObject === null || findMRPObject === void 0 ? void 0 : findMRPObject.EditableRange,
                                        PriceGroupCategoryId: findMRPObject === null || findMRPObject === void 0 ? void 0 : findMRPObject.PriceGroupCategoryId,
                                        PriceGroupCategoryKey: findMRPObject === null || findMRPObject === void 0 ? void 0 : findMRPObject.PriceGroupCategoryKey,
                                        EffectiveFromDate: findMRPObject === null || findMRPObject === void 0 ? void 0 : findMRPObject.EffectiveFromDate,
                                        EffectiveToDate: findMRPObject === null || findMRPObject === void 0 ? void 0 : findMRPObject.EffectiveToDate
                                    });
                                    finalList_1.push(_objectSpread(_objectSpread({}, masterItem), updatedItem));
                                }
                                else if (isDeclined) {
                                    var findMRPObject = masterItem.Price.find(function (item) {
                                        var _isDeclined$SavedPric;
                                        return item.MRP === ((_isDeclined$SavedPric = isDeclined.SavedPriceWithTaxDeclined) === null || _isDeclined$SavedPric === void 0 ? void 0 : _isDeclined$SavedPric.MRP);
                                    });
                                    var updatedItem = _objectSpread({}, isDeclined);
                                    updatedItem.isExpanded = true;
                                    updatedItem.DeclinedRemarks = updatedItem.Remarks ? updatedItem.Remarks : "";
                                    updatedItem.RejectReasonRemark = updatedItem.DeclinedJobReasonId ? updatedItem.DeclinedJobReasonId : "";
                                    updatedItem.jobType = masterItem.jobType;
                                    updatedItem.PartName = masterItem.jobType === "Part" ? masterItem.PartName : "";
                                    updatedItem.LabourName = masterItem.jobType === "Labour" ? masterItem.LabourName : "";
                                    updatedItem.Quantity = masterItem.Quantity;
                                    // updatedItem.Price = Number((Number(masterItem?.Price ?? 0) * Number(masterItem?.Quantity)).toFixed(2))
                                    updatedItem.Price = masterItem.Price;
                                    updatedItem.SelectedPriceDetails = _objectSpread(_objectSpread({}, isDeclined.SavedPriceWithTaxDeclined), {}, {
                                        MaxPrice: findMRPObject === null || findMRPObject === void 0 ? void 0 : findMRPObject.MaxPrice,
                                        MinPrice: findMRPObject === null || findMRPObject === void 0 ? void 0 : findMRPObject.MinPrice,
                                        EditableRange: findMRPObject === null || findMRPObject === void 0 ? void 0 : findMRPObject.EditableRange
                                    });
                                    updatedItem.LabourCode = masterItem.jobType === "Labour" ? masterItem.LabourCode : "";
                                    updatedItem.PartCode = masterItem.jobType === "Part" ? masterItem.PartCode : "";
                                    finalList_1.push(updatedItem);
                                }
                                else {
                                    var updatedItem = _objectSpread({}, masterItem);
                                    updatedItem.SelectedPriceDetails = (updatedItem === null || updatedItem === void 0 ? void 0 : updatedItem.Price.length) > 0 ? updatedItem === null || updatedItem === void 0 ? void 0 : updatedItem.Price[0] : [];
                                    updatedItem.isExpanded = false;
                                    // updatedItem.Price = Number((Number(masterItem?.Price ?? 0) * Number(masterItem?.Quantity)).toFixed(2))
                                    finalList_1.push(updatedItem);
                                }
                            });
                            setIsSkeleton(false);
                            setpmPartsList(finalList_1);
                            PmTotalPrice_1 = 0;
                            finalList_1.map(function (item) {
                                if (!(item !== null && item !== void 0 && item.isExpanded)) {
                                    var _item$SelectedPriceDe, _item$SelectedPriceDe2;
                                    var amount = item !== null && item !== void 0 && (_item$SelectedPriceDe = item.SelectedPriceDetails) !== null && _item$SelectedPriceDe !== void 0 && _item$SelectedPriceDe.Amount ? item === null || item === void 0 || (_item$SelectedPriceDe2 = item.SelectedPriceDetails) === null || _item$SelectedPriceDe2 === void 0 ? void 0 : _item$SelectedPriceDe2.Amount : 0;
                                    PmTotalPrice_1 += amount;
                                }
                            });
                            dispatch(setState({
                                key: "TotalPMPartPrice",
                                value: PmTotalPrice_1
                            }));
                        }
                        // setDisableSave(true)
                    }
                    else {
                        setIsSkeleton(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getPrecheckAnswersByModelId = function () { return __awaiter(void 0, void 0, void 0, function () {
        var answersResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(getByIdAPI({
                        key: "",
                        url: "".concat(Config.baseURL + props.apiRequestParam, "/InspectionPreCheckList"),
                        request: props.apiRequestPayload
                    }))];
                case 1:
                    answersResponse = _a.sent();
                    if (answersResponse.payload.success) {
                        return [2 /*return*/, answersResponse.payload.data.Options];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getFuelLevel = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _ModuleDetailsGetById22, productAttributeBody, productAttributeResult, fuelAttributeValue, _ModuleDetailsGetById23, requestBody, QuestionsResponse, QuestionsList, questionsAnswers_1, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!props.parentModuleDocumentId) return [3 /*break*/, 4];
                    productAttributeBody = {
                        ProductId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById22 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById22 === void 0 ? void 0 : _ModuleDetailsGetById22.ProductId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: productAttributeValueUrl,
                            request: productAttributeBody
                        }))];
                case 1:
                    productAttributeResult = _a.sent();
                    if (!(productAttributeResult.payload.value.success && productAttributeResult.payload.value.data)) return [3 /*break*/, 4];
                    fuelAttributeValue = productAttributeResult.payload.value.data.Value;
                    if (!fuelAttributeValue) return [3 /*break*/, 4];
                    requestBody = {
                        SystemName: "FuelUsed-".concat(fuelAttributeValue),
                        ProductId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById23 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById23 === void 0 ? void 0 : _ModuleDetailsGetById23.ProductId,
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: precheckDynamicCheckListFormUrl,
                            request: requestBody
                        }))];
                case 2:
                    QuestionsResponse = _a.sent();
                    if (!QuestionsResponse.payload.value.success) return [3 /*break*/, 4];
                    QuestionsList = QuestionsResponse.payload.value.data;
                    return [4 /*yield*/, getPrecheckAnswersByModelId()];
                case 3:
                    questionsAnswers_1 = _a.sent();
                    setPrecheckQuestionsAnswer(questionsAnswers_1);
                    result = QuestionsList.map(function (questionGroupItem) {
                        if (questionGroupItem.Questions && questionGroupItem.Questions.length > 0) {
                            var SortedQuestionsBySequence = __spreadArray([], questionGroupItem.Questions, true).sort(function (a, b) { return a.Sequence - b.Sequence; });
                            return _objectSpread(_objectSpread({}, questionGroupItem), {}, {
                                Questions: SortedQuestionsBySequence.map(function (questionItem) {
                                    // const questionControlType = controlTypesList.find((item: any) => item.id === questionItem.ControlId);
                                    var questionAnswerItem = questionsAnswers_1.find(function (item) { return item.QuestionId === questionItem.QuestionId; });
                                    return _objectSpread(_objectSpread({}, questionItem), {}, {
                                        // ControlName: questionControlType && questionControlType.DisplayName ? questionControlType.DisplayName : '',
                                        ResponseValue: questionAnswerItem && questionAnswerItem.ResponseValue ? questionAnswerItem.ResponseValue : ""
                                    });
                                })
                            });
                        }
                    });
                    setFuelIndicatorDynamicListTaskDetails(result);
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var getJobItems = function (preJobCardId, countObj) { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload5, _result$payload6, requestBody, result, _result$payload7, savedCount;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        PreJobCardDocumentId: preJobCardId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "customerDetailsTrnalsteToJob",
                            url: getSavedJobItemsUrl,
                            request: requestBody
                        }))];
                case 1:
                    result = _a.sent();
                    if ((_result$payload5 = result.payload) !== null && _result$payload5 !== void 0 && (_result$payload5 = _result$payload5.value) !== null && _result$payload5 !== void 0 && _result$payload5.success && (_result$payload6 = result.payload) !== null && _result$payload6 !== void 0 && (_result$payload6 = _result$payload6.value) !== null && _result$payload6 !== void 0 && _result$payload6.data) {
                        savedCount = (_result$payload7 = result.payload) === null || _result$payload7 === void 0 || (_result$payload7 = _result$payload7.value) === null || _result$payload7 === void 0 ? void 0 : _result$payload7.data;
                        setJobCount(_objectSpread(_objectSpread({}, countObj), {}, {
                            jobItems: savedCount === null || savedCount === void 0 ? void 0 : savedCount.length
                        }));
                        setToggle(_objectSpread(_objectSpread({}, countObj), {}, {
                            jobItems: savedCount === null || savedCount === void 0 ? void 0 : savedCount.length
                        }));
                        moduleCountForHeader(_objectSpread(_objectSpread({}, countObj), {}, {
                            jobItems: savedCount === null || savedCount === void 0 ? void 0 : savedCount.length
                        }));
                        dispatch(setState({
                            key: "getModuleHeaderCount",
                            value: _objectSpread(_objectSpread({}, countObj), {}, {
                                jobItems: savedCount === null || savedCount === void 0 ? void 0 : savedCount.length
                            })
                        }));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getInitialData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, _ModuleDetailsGetById24, _data, updatedList_1, obj_1, newArray_1, finalModuleSectionArray_1, res, sortedArray;
        return __generator(this, function (_a) {
            try {
                data = [];
                if (props.parentModuleName === EParentModuleName.Appointment) {
                    data = getLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_APPOINTMENT);
                }
                else if (props.parentModuleName === EParentModuleName.ServiceEstimate) {
                    if ((ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById24 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById24 === void 0 ? void 0 : _ModuleDetailsGetById24.EstimateType) === "RevisedEstimate") {
                        data = getLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_REVISEDESTIMATE);
                    }
                    else {
                        data = getLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_ESTIMATE);
                    }
                }
                else if (props.parentModuleName === EParentModuleName.Inspection) {
                    data = getLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_INSPECTION);
                }
                if (updatedModuleSectionByChannel.length == 0) {
                    if (((_data = data) === null || _data === void 0 ? void 0 : _data.length) > 0) {
                        updatedList_1 = [];
                        data.map(function (item) {
                            var newObj = Object.assign({}, item, item.Section);
                            delete newObj.Section;
                            updatedList_1.push(_objectSpread(_objectSpread({}, newObj), {}, {
                                isAccordianOpen: false
                            }));
                        });
                        obj_1 = {};
                        newArray_1 = [];
                        finalModuleSectionArray_1 = [];
                        res = updatedList_1.map(function (elem) {
                            var newSectionAttribute = elem.SectionAttributes;
                            var mergedObj = null;
                            var newAttribute = newSectionAttribute.map(function (el) {
                                if (el !== null && el !== void 0 && el.Key && !el.IsDeleted) {
                                    obj_1[el.Key] = el.Value === ESectionAttributeValue.ON ? true : false;
                                    obj_1[el.Key + "DefaultValue"] = el.DefaultValue === ESectionAttributeValue.ON ? true : false;
                                    mergedObj = _objectSpread(_objectSpread({}, el), obj_1);
                                }
                            });
                            if (mergedObj) {
                                newArray_1.push(mergedObj);
                            }
                            obj_1 = {};
                            delete elem.SectionAttributes;
                            elem["SectionAttributes"] = [];
                            newArray_1.forEach(function (value) {
                                newSectionAttribute.forEach(function (value1) {
                                    if (value.id == value1.id) {
                                        elem.SectionAttributes.push(value);
                                    }
                                });
                            });
                            finalModuleSectionArray_1.push(elem);
                        });
                        sortedArray = finalModuleSectionArray_1 === null || finalModuleSectionArray_1 === void 0 ? void 0 : finalModuleSectionArray_1.sort(function (a, b) { return a.Sequence - b.Sequence; });
                        dispatch(setUpdatedModuleSectionByChannel(sortedArray));
                        performAllButtonAction(sortedArray);
                        getDisabled();
                    }
                }
            }
            catch (e) {
                console.log("Error-", e);
            }
            return [2 /*return*/];
        });
    }); };
    var getPreviousDeclinedJobsAPI = function (Limit, LimitDays) { return __awaiter(void 0, void 0, void 0, function () {
        var request, _ModuleDetailsGetById25, _ModuleDetailsGetById26, result, jcLIdList_1, updatedData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {};
                    if (LimitDays !== null && LimitDays !== void 0 && LimitDays.Value) {
                        request = {
                            InstallBaseId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById25 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById25 === void 0 ? void 0 : _ModuleDetailsGetById25.InstallBaseId,
                            OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                            ParentOrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
                            LimitDays: parseInt(LimitDays === null || LimitDays === void 0 ? void 0 : LimitDays.Value)
                        };
                    }
                    else {
                        request = {
                            InstallBaseId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById26 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById26 === void 0 ? void 0 : _ModuleDetailsGetById26.InstallBaseId,
                            Limit: parseInt(Limit === null || Limit === void 0 ? void 0 : Limit.Value),
                            OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                            ParentOrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId
                        };
                    }
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "previousJobCards",
                            url: previousJobCard,
                            request: _objectSpread({}, request)
                        }))];
                case 1:
                    result = _a.sent();
                    if (!(result.payload.value.success && result.payload.value.data)) return [3 /*break*/, 3];
                    return [4 /*yield*/, getDeclinedCountsByJcId(result.payload.value.data)];
                case 2:
                    jcLIdList_1 = _a.sent();
                    updatedData = _objectSpread({}, result.payload.value);
                    if (updatedData && updatedData.data && Array.isArray(updatedData.data)) {
                        updatedData.data = updatedData.data.filter(function (item) { return jcLIdList_1.includes(item.id); });
                    }
                    setPreviousJobCards(updatedData);
                    return [2 /*return*/, updatedData];
                case 3: return [2 /*return*/, null];
            }
        });
    }); };
    var getCountModuleWise = function (jobItemsCount) { return __awaiter(void 0, void 0, void 0, function () {
        var request, response, countObj, _ModuleDetailsGetById27, _response, _response2, _response3, _ModuleDetailsGetById28, _response4, _response5, request1, _response6, _ModuleDetailsGetById29, _response7, _response8, request2, _response9, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 9, , 10]);
                    if (!!(jobItemsCount !== null && jobItemsCount !== void 0 && jobItemsCount.PeriodicParts)) return [3 /*break*/, 7];
                    request = {};
                    response = void 0;
                    countObj = {};
                    if (!(props.parentModuleName === EParentModuleName.Appointment)) return [3 /*break*/, 2];
                    request = {
                        AppointmentId: documentId !== null && documentId !== void 0 ? documentId : "",
                        RepairTypeId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById27 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById27 === void 0 ? void 0 : _ModuleDetailsGetById27.RepairTypeId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "appointmentCount",
                            url: AppointmentJobCountUrl,
                            request: request
                        }))];
                case 1:
                    response = _a.sent();
                    if ((_response = response) !== null && _response !== void 0 && (_response = _response.payload) !== null && _response !== void 0 && (_response = _response.value) !== null && _response !== void 0 && _response.success && ((_response2 = response) === null || _response2 === void 0 || (_response2 = _response2.payload) === null || _response2 === void 0 || (_response2 = _response2.value) === null || _response2 === void 0 ? void 0 : _response2.statusCode) == 200) {
                        countObj = (_response3 = response) === null || _response3 === void 0 || (_response3 = _response3.payload) === null || _response3 === void 0 || (_response3 = _response3.value) === null || _response3 === void 0 ? void 0 : _response3.data;
                    }
                    return [3 /*break*/, 6];
                case 2:
                    if (!(props.parentModuleName === EParentModuleName.Inspection)) return [3 /*break*/, 4];
                    request1 = {
                        InspectionId: documentId !== null && documentId !== void 0 ? documentId : "",
                        RepairTypeId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById28 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById28 === void 0 ? void 0 : _ModuleDetailsGetById28.RepairTypeId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "vehicleInspectionCount",
                            url: VehicleInspectionJobCountUrl,
                            request: request1
                        }))];
                case 3:
                    response = _a.sent();
                    if ((_response4 = response) !== null && _response4 !== void 0 && (_response4 = _response4.payload) !== null && _response4 !== void 0 && (_response4 = _response4.value) !== null && _response4 !== void 0 && _response4.success && ((_response5 = response) === null || _response5 === void 0 || (_response5 = _response5.payload) === null || _response5 === void 0 || (_response5 = _response5.value) === null || _response5 === void 0 ? void 0 : _response5.statusCode) == 200) {
                        countObj = (_response6 = response) === null || _response6 === void 0 || (_response6 = _response6.payload) === null || _response6 === void 0 || (_response6 = _response6.value) === null || _response6 === void 0 ? void 0 : _response6.data;
                    }
                    return [3 /*break*/, 6];
                case 4:
                    if (!(props.parentModuleName === EParentModuleName.ServiceEstimate)) return [3 /*break*/, 6];
                    request2 = {
                        EstimateId: documentId !== null && documentId !== void 0 ? documentId : "",
                        RepairTypeId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById29 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById29 === void 0 ? void 0 : _ModuleDetailsGetById29.RepairTypeId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "estimateCount",
                            url: EstimateJobCountUrl,
                            request: request2
                        }))];
                case 5:
                    response = _a.sent();
                    if ((_response7 = response) !== null && _response7 !== void 0 && (_response7 = _response7.payload) !== null && _response7 !== void 0 && (_response7 = _response7.value) !== null && _response7 !== void 0 && _response7.success && ((_response8 = response) === null || _response8 === void 0 || (_response8 = _response8.payload) === null || _response8 === void 0 || (_response8 = _response8.value) === null || _response8 === void 0 ? void 0 : _response8.statusCode) == 200) {
                        countObj = (_response9 = response) === null || _response9 === void 0 || (_response9 = _response9.payload) === null || _response9 === void 0 || (_response9 = _response9.value) === null || _response9 === void 0 ? void 0 : _response9.data;
                    }
                    _a.label = 6;
                case 6:
                    if (documentId) {
                        getJobItems(documentId, countObj);
                    }
                    else {
                        setJobCount(countObj);
                        setToggle(countObj);
                        moduleCountForHeader(countObj);
                    }
                    return [3 /*break*/, 8];
                case 7:
                    setToggle(jobItemsCount);
                    moduleCountForHeader(jobItemsCount);
                    _a.label = 8;
                case 8: return [3 /*break*/, 10];
                case 9:
                    e_2 = _a.sent();
                    console.log("Error-", e_2);
                    return [3 /*break*/, 10];
                case 10: return [2 /*return*/];
            }
        });
    }); };
    var getAlternatePartConfig = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload8, _result$payload9, request, result, _result$payload10, config, AdditionalJobsFlag, StandardServicesFlag, PeriodicMaintenanceFlag;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        SystemName: props.parentModuleName,
                        OrganizationId: selectedBranch.OrganizationId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: AlternatePartConfigUrl,
                            request: request
                        }))];
                case 1:
                    result = _a.sent();
                    if ((_result$payload8 = result.payload) !== null && _result$payload8 !== void 0 && (_result$payload8 = _result$payload8.value) !== null && _result$payload8 !== void 0 && _result$payload8.success && (_result$payload9 = result.payload) !== null && _result$payload9 !== void 0 && (_result$payload9 = _result$payload9.value) !== null && _result$payload9 !== void 0 && _result$payload9.data) {
                        config = (_result$payload10 = result.payload) === null || _result$payload10 === void 0 || (_result$payload10 = _result$payload10.value) === null || _result$payload10 === void 0 ? void 0 : _result$payload10.data;
                        AdditionalJobsFlag = getAlternatePartConfigByTaskName(ETaskName.AdditionalJobs, config);
                        StandardServicesFlag = getAlternatePartConfigByTaskName(ETaskName.StandardServices, config);
                        PeriodicMaintenanceFlag = getAlternatePartConfigByTaskName(ETaskName.PeriodicMaintenance, config);
                        setAlternatePartConfigState(_objectSpread(_objectSpread({}, alternatePartConfigState), {}, {
                            "Additional Jobs": AdditionalJobsFlag,
                            "Standard Services": StandardServicesFlag,
                            "Periodic Maintenance": PeriodicMaintenanceFlag
                        }));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var moduleCountForHeader = function (countObj) {
        dispatch(setState({
            key: "getModuleHeaderCount",
            value: _objectSpread(_objectSpread({}, getModuleHeaderCount), countObj)
        }));
    };
    var setToggle = function (countObj) {
        if ((countObj === null || countObj === void 0 ? void 0 : countObj.RoadTest) > 0 && !getTaskDetailsToggleValue.roadTestToggle) {
            dispatch(setTaskDetailsToggleValue(_objectSpread(_objectSpread({}, getTaskDetailsToggleValue), {}, {
                roadTestToggle: true
            })));
        }
        if ((countObj === null || countObj === void 0 ? void 0 : countObj.PeriodicParts) > 0 && !getTaskDetailsToggleValue.periodicMaintenanceToggle) {
            dispatch(setTaskDetailsToggleValue(_objectSpread(_objectSpread({}, getTaskDetailsToggleValue), {}, {
                periodicMaintenanceToggle: true
            })));
        }
        if ((countObj === null || countObj === void 0 ? void 0 : countObj.StandardParts) > 0 && !getTaskDetailsToggleValue.standardJobsToggle) {
            dispatch(setTaskDetailsToggleValue(_objectSpread(_objectSpread({}, getTaskDetailsToggleValue), {}, {
                standardJobsToggle: true
            })));
        }
        if ((countObj === null || countObj === void 0 ? void 0 : countObj.AdditionalParts) > 0 && !getTaskDetailsToggleValue.additionalJobsToggle) {
            dispatch(setTaskDetailsToggleValue(_objectSpread(_objectSpread({}, getTaskDetailsToggleValue), {}, {
                additionalJobsToggle: true
            })));
        }
    };
    var performAllButtonAction = function (finalModuleSectionArray) {
        try {
            if (finalModuleSectionArray.length > 0) {
                var count_1 = 0;
                finalModuleSectionArray.map(function (item) {
                    var _item$SectionAttribut, _item$SectionAttribut2;
                    if (item !== null && item !== void 0 && (_item$SectionAttribut = item.SectionAttributes[0]) !== null && _item$SectionAttribut !== void 0 && _item$SectionAttribut.MANDATORYDefaultValue || item !== null && item !== void 0 && (_item$SectionAttribut2 = item.SectionAttributes[0]) !== null && _item$SectionAttribut2 !== void 0 && _item$SectionAttribut2.OPTIONALDefaultValue) {
                        count_1 = count_1 + 1;
                    }
                });
                if ((finalModuleSectionArray === null || finalModuleSectionArray === void 0 ? void 0 : finalModuleSectionArray.length) === count_1) {
                    setAllSwitchEnabled(!allswitchEnabled);
                }
            }
        }
        catch (e) {
            console.log("Error-", e);
        }
    };
    var onClickBackArrow = function () {
        trackButtonClick("ButtonClickEvent", "OnBackArrowClick", undefined);
        if (props.isDisabled) {
            dispatch(resetState(["customerDetailsTrnalsteToJob", "ModuleDetailsGetById"]));
            if (props.parentModuleName === EParentModuleName.ServiceEstimate) {
                navigate("/serviceEstimate-details-created/".concat(props.parentModuleDocumentId));
            }
            if (props.parentModuleName === EParentModuleName.Appointment) {
                navigate("/appointment-Detail/".concat(props.parentModuleDocumentId));
            }
            if (props.parentModuleName === EParentModuleName.Inspection) {
                navigate("/inspection-Detail/".concat(props.parentModuleDocumentId));
            }
        }
        else {
            if (isTaskDetailDataUpdated) {
                setOpenPopup(true);
            }
            else {
                onClickNoBtn();
            }
        }
    };
    var handleAllSwitchButtonState = function () {
        if (updatedModuleSectionByChannel.length > 0) {
            dispatch(setTaskDetailsToggleValue({
                roadTestToggle: !allswitchEnabled,
                periodicMaintenanceToggle: !allswitchEnabled,
                standardJobsToggle: !allswitchEnabled,
                additionalJobsToggle: !allswitchEnabled,
                preCheckToggle: !allswitchEnabled
            }));
            setAllSwitchEnabled(!allswitchEnabled);
            var sortedList_1 = [];
            updatedModuleSectionByChannel === null || updatedModuleSectionByChannel === void 0 || updatedModuleSectionByChannel.map(function (item) {
                var data = cloneDeep(item);
                if (data.SectionAttributes.length > 0) {
                    data.SectionAttributes[0].OPTIONAL = !allswitchEnabled;
                    data.SectionAttributes[0].OPTIONALDefaultValue = !allswitchEnabled;
                    data.SectionAttributes[0].MANDATORYDefaultValue = data.SectionAttributes[0].MANDATORY ? data.SectionAttributes[0].MANDATORYDefaultValue : !allswitchEnabled;
                    sortedList_1.push(data);
                }
                else {
                    sortedList_1.push(data);
                }
            });
            dispatch(setUpdatedModuleSectionByChannel(sortedList_1));
        }
    };
    var getStandaredJobApiCall = function () {
        setCallApi(true);
    };
    var getAdditionalJobApiCall = function () {
        setAddiotionalJobApiCall(true);
    };
    var onClickNoBtn = function () {
        trackButtonClick("ButtonClickEvent", "OnNoClickButton", undefined);
        dispatch(resetState(["customerDetailsTrnalsteToJob", "preDocumentFetch", "customerComplaintDataImageAndAudio"]));
        setOpenPopup(false);
        if (props.parentModuleName === EParentModuleName.ServiceEstimate) {
            var _profileData$data, _profileData$data2, _profileData$data3, _profileData$data4, _profileData$data5, _profileData$data6, _profileData$data7, _profileData$data8;
            // mixpanel.track(`${props.parentModuleName}_No_Button_Click` + ` / ${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` / ${profileData?.data?.IdentityId}`, {
            //   'id': profileData?.data?.IdentityId,          // Transaction ID.
            //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
            //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
            //   'date': new Date() + profileData?.data?.IdentityId,
            //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
            //   'mode': 'Edit',
            //   'documentId': props.parentModuleDocumentId,
            //   'navigateTo': 'ServiceEstimate Details Created Page'
            // });
            // window.gtag(
            //   'event', `${props.parentModuleName}_No_Button_Click`, {
            //   'id': profileData?.data?.IdentityId,          // Transaction ID.
            //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
            //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
            //   'date': new Date() + profileData?.data?.IdentityId,
            //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
            //   'mode': 'Edit',
            //   'documentId': props.parentModuleDocumentId,
            //   'navigateTo': 'ServiceEstimate Details Created Page'
            // });
            transactionEventLog("".concat(props.parentModuleName, "_No_Button_Click"), {
                'id': profileData === null || profileData === void 0 || (_profileData$data = profileData.data) === null || _profileData$data === void 0 ? void 0 : _profileData$data.IdentityId,
                // Transaction ID.
                'name': "".concat(profileData === null || profileData === void 0 || (_profileData$data2 = profileData.data) === null || _profileData$data2 === void 0 ? void 0 : _profileData$data2.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data3 = profileData.data) === null || _profileData$data3 === void 0 ? void 0 : _profileData$data3.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data4 = profileData.data) === null || _profileData$data4 === void 0 ? void 0 : _profileData$data4.IdentityId),
                'code': "".concat(profileData === null || profileData === void 0 || (_profileData$data5 = profileData.data) === null || _profileData$data5 === void 0 ? void 0 : _profileData$data5.Code) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data6 = profileData.data) === null || _profileData$data6 === void 0 ? void 0 : _profileData$data6.IdentityId),
                'date': new Date() + (profileData === null || profileData === void 0 || (_profileData$data7 = profileData.data) === null || _profileData$data7 === void 0 ? void 0 : _profileData$data7.IdentityId),
                'path': "".concat(window.location.href) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data8 = profileData.data) === null || _profileData$data8 === void 0 ? void 0 : _profileData$data8.IdentityId),
                'mode': 'Edit',
                'documentId': props.parentModuleDocumentId,
                'navigateTo': 'ServiceEstimate Details Created Page'
            }, profileData);
            navigate("/serviceEstimate-details-created/".concat(props.parentModuleDocumentId));
        }
        if (props.parentModuleName === EParentModuleName.Appointment) {
            var _profileData$data9, _profileData$data10, _profileData$data11, _profileData$data12, _profileData$data13, _profileData$data14, _profileData$data15, _profileData$data16;
            // mixpanel.track(`${props.parentModuleName}_No_Button_Click` + ` / ${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` / ${profileData?.data?.IdentityId}`, {
            //   'id': profileData?.data?.IdentityId,          // Transaction ID.
            //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
            //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
            //   'date': new Date() + profileData?.data?.IdentityId,
            //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
            //   'mode': 'Edit',
            //   'documentId': props.parentModuleDocumentId,
            //   'navigateTo': 'Appointment Details Page'
            // });
            // window.gtag(
            //   'event', `${props.parentModuleName}_No_Button_Click`, {
            //   'id': profileData?.data?.IdentityId,          // Transaction ID.
            //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
            //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
            //   'date': new Date() + profileData?.data?.IdentityId,
            //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
            //   'mode': 'Edit',
            //   'documentId': props.parentModuleDocumentId,
            //   'navigateTo': 'Appointment Details Page'
            // });
            transactionEventLog("".concat(props.parentModuleName, "_No_Button_Click"), {
                'id': profileData === null || profileData === void 0 || (_profileData$data9 = profileData.data) === null || _profileData$data9 === void 0 ? void 0 : _profileData$data9.IdentityId,
                // Transaction ID.
                'name': "".concat(profileData === null || profileData === void 0 || (_profileData$data10 = profileData.data) === null || _profileData$data10 === void 0 ? void 0 : _profileData$data10.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data11 = profileData.data) === null || _profileData$data11 === void 0 ? void 0 : _profileData$data11.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data12 = profileData.data) === null || _profileData$data12 === void 0 ? void 0 : _profileData$data12.IdentityId),
                'code': "".concat(profileData === null || profileData === void 0 || (_profileData$data13 = profileData.data) === null || _profileData$data13 === void 0 ? void 0 : _profileData$data13.Code) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data14 = profileData.data) === null || _profileData$data14 === void 0 ? void 0 : _profileData$data14.IdentityId),
                'date': new Date() + (profileData === null || profileData === void 0 || (_profileData$data15 = profileData.data) === null || _profileData$data15 === void 0 ? void 0 : _profileData$data15.IdentityId),
                'path': "".concat(window.location.href) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data16 = profileData.data) === null || _profileData$data16 === void 0 ? void 0 : _profileData$data16.IdentityId),
                'mode': 'Edit',
                'documentId': props.parentModuleDocumentId,
                'navigateTo': 'Appointment Details Page'
            }, profileData);
            navigate("/appointment-Detail/".concat(props.parentModuleDocumentId));
        }
        if (props.parentModuleName === EParentModuleName.Inspection) {
            var _profileData$data17, _profileData$data18, _profileData$data19, _profileData$data20, _profileData$data21, _profileData$data22, _profileData$data23, _profileData$data24;
            // mixpanel.track(`${props.parentModuleName}_No_Button_Click` + ` / ${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` / ${profileData?.data?.IdentityId}`, {
            //   'id': profileData?.data?.IdentityId,          // Transaction ID.
            //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
            //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
            //   'date': new Date() + profileData?.data?.IdentityId,
            //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
            //   'mode': 'Edit',
            //   'documentId': props.parentModuleDocumentId,
            //   'navigateTo': 'Inspection Details Page'
            // });
            // window.gtag(
            //   'event', `${props.parentModuleName}_No_Button_Click`, {
            //   'id': profileData?.data?.IdentityId,          // Transaction ID.
            //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
            //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
            //   'date': new Date() + profileData?.data?.IdentityId,
            //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
            //   'mode': 'Edit',
            //   'documentId': props.parentModuleDocumentId,
            //   'navigateTo': 'Inspection Details Page'
            // });
            transactionEventLog("".concat(props.parentModuleName, "_No_Button_Click"), {
                'id': profileData === null || profileData === void 0 || (_profileData$data17 = profileData.data) === null || _profileData$data17 === void 0 ? void 0 : _profileData$data17.IdentityId,
                // Transaction ID.
                'name': "".concat(profileData === null || profileData === void 0 || (_profileData$data18 = profileData.data) === null || _profileData$data18 === void 0 ? void 0 : _profileData$data18.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data19 = profileData.data) === null || _profileData$data19 === void 0 ? void 0 : _profileData$data19.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data20 = profileData.data) === null || _profileData$data20 === void 0 ? void 0 : _profileData$data20.IdentityId),
                'code': "".concat(profileData === null || profileData === void 0 || (_profileData$data21 = profileData.data) === null || _profileData$data21 === void 0 ? void 0 : _profileData$data21.Code) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data22 = profileData.data) === null || _profileData$data22 === void 0 ? void 0 : _profileData$data22.IdentityId),
                'date': new Date() + (profileData === null || profileData === void 0 || (_profileData$data23 = profileData.data) === null || _profileData$data23 === void 0 ? void 0 : _profileData$data23.IdentityId),
                'path': "".concat(window.location.href) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data24 = profileData.data) === null || _profileData$data24 === void 0 ? void 0 : _profileData$data24.IdentityId),
                'mode': 'Edit',
                'documentId': props.parentModuleDocumentId,
                'navigateTo': 'Inspection Details Page'
            }, profileData);
            navigate("/inspection-Detail/".concat(props.parentModuleDocumentId));
        }
        dispatch(setIsTaskDetailsDataUpdated(false));
        dispatch(setTaskDetailsDataSaved(false));
        dispatch(setTaskDetailsToggleValue({
            roadTestToggle: false,
            periodicMaintenanceToggle: false,
            standardJobsToggle: false,
            additionalJobsToggle: false,
            preCheckToggle: false
        }));
    };
    var goToHomePage = function () {
        trackButtonClick("ButtonClickEvent", "goToHomePageClick", undefined);
        navigate("/appointment");
    };
    var onClickYesBtn = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            trackButtonClick("ButtonClickEvent", "OnYesClick", undefined);
            setOpenPopup(false);
            return [2 /*return*/];
        });
    }); };
    var modifyAndCloneEstimate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _estimateResponse$pay, _estimateResponse$pay2, _estimateResponse$pay3, requestBody, estimateResponse, _estimateResponse$pay4, _estimateResponse$pay5, _modifyEstimateRespon, modifyEstimateResponse, _estimateResponse$pay6, _profileData$data25, _profileData$data26, _profileData$data27, _profileData$data28, _profileData$data29, _profileData$data30, _profileData$data31, _profileData$data32, _estimateResponse$pay7, _profileData$data33, _profileData$data34, _profileData$data35, _profileData$data36, _profileData$data37, _profileData$data38, _profileData$data39, _profileData$data40;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        PreJobCardDocumentId: documentId,
                        HasChild: true
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: ViewEstimateUrl,
                            request: requestBody
                        }))];
                case 1:
                    estimateResponse = _a.sent();
                    if (!(estimateResponse !== null && estimateResponse !== void 0 && (_estimateResponse$pay = estimateResponse.payload) !== null && _estimateResponse$pay !== void 0 && (_estimateResponse$pay = _estimateResponse$pay.data) !== null && _estimateResponse$pay !== void 0 && _estimateResponse$pay.PreJobCardDocumentId && estimateResponse !== null && estimateResponse !== void 0 && (_estimateResponse$pay2 = estimateResponse.payload) !== null && _estimateResponse$pay2 !== void 0 && _estimateResponse$pay2.success && (estimateResponse === null || estimateResponse === void 0 || (_estimateResponse$pay3 = estimateResponse.payload) === null || _estimateResponse$pay3 === void 0 ? void 0 : _estimateResponse$pay3.statusCode) == 200)) return [3 /*break*/, 7];
                    if (!((estimateResponse === null || estimateResponse === void 0 || (_estimateResponse$pay4 = estimateResponse.payload) === null || _estimateResponse$pay4 === void 0 || (_estimateResponse$pay4 = _estimateResponse$pay4.data) === null || _estimateResponse$pay4 === void 0 ? void 0 : _estimateResponse$pay4.Key) === StatusEnum.ApprovalPending || (estimateResponse === null || estimateResponse === void 0 || (_estimateResponse$pay5 = estimateResponse.payload) === null || _estimateResponse$pay5 === void 0 || (_estimateResponse$pay5 = _estimateResponse$pay5.data) === null || _estimateResponse$pay5 === void 0 ? void 0 : _estimateResponse$pay5.Key) === StatusEnum.Created)) return [3 /*break*/, 5];
                    return [4 /*yield*/, dispatch(updateAPI({
                            key: "",
                            url: "".concat(Config.baseURL, "Estimate/").concat(estimateResponse.payload.data.PreJobCardDocumentId, "/ModifyEstimatewithClone")
                        }))];
                case 2:
                    modifyEstimateResponse = _a.sent();
                    if (!(modifyEstimateResponse && (_modifyEstimateRespon = modifyEstimateResponse.payload) !== null && _modifyEstimateRespon !== void 0 && _modifyEstimateRespon.success)) return [3 /*break*/, 4];
                    return [4 /*yield*/, dispatch(setUpdatedModuleSectionByChannel([]))];
                case 3:
                    _a.sent();
                    dispatch(resetState(["documentDetailsGetById", "preDocumentFetch", "getCustomerInfo", "ModuleDetailsGetById", "additionalEstimateDetail"]));
                    // mixpanel.track(`${estimateResponse?.payload?.data?.Key}_Inspection_${handleButtonNames()}_Click` + ` / ${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` / ${profileData?.data?.IdentityId}`, {
                    //   'id': profileData?.data?.IdentityId,          // Transaction ID.
                    //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
                    //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
                    //   'date': new Date() + profileData?.data?.IdentityId,
                    //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
                    //   'mode': 'Edit',
                    //   'documentId': estimateResponse.payload.data.PreJobCardDocumentId,
                    //   'navigateTo': 'ServiceEstimate Details Jobcard Page'
                    // });
                    // window.gtag(
                    //   'event', `${estimateResponse?.payload?.data?.Key}_Inspection_${handleButtonNames()}_Click`, {
                    //   'id': profileData?.data?.IdentityId,          // Transaction ID.
                    //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
                    //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
                    //   'date': new Date() + profileData?.data?.IdentityId,
                    //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
                    //   'mode': 'Edit',
                    //   'documentId': estimateResponse.payload.data.PreJobCardDocumentId,
                    //   'navigateTo': 'ServiceEstimate Details Jobcard Page'
                    // });
                    transactionEventLog("".concat(estimateResponse === null || estimateResponse === void 0 || (_estimateResponse$pay6 = estimateResponse.payload) === null || _estimateResponse$pay6 === void 0 || (_estimateResponse$pay6 = _estimateResponse$pay6.data) === null || _estimateResponse$pay6 === void 0 ? void 0 : _estimateResponse$pay6.Key, "_Inspection_").concat(handleButtonNames(), "_Click"), {
                        'id': profileData === null || profileData === void 0 || (_profileData$data25 = profileData.data) === null || _profileData$data25 === void 0 ? void 0 : _profileData$data25.IdentityId,
                        // Transaction ID.
                        'name': "".concat(profileData === null || profileData === void 0 || (_profileData$data26 = profileData.data) === null || _profileData$data26 === void 0 ? void 0 : _profileData$data26.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data27 = profileData.data) === null || _profileData$data27 === void 0 ? void 0 : _profileData$data27.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data28 = profileData.data) === null || _profileData$data28 === void 0 ? void 0 : _profileData$data28.IdentityId),
                        'code': "".concat(profileData === null || profileData === void 0 || (_profileData$data29 = profileData.data) === null || _profileData$data29 === void 0 ? void 0 : _profileData$data29.Code) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data30 = profileData.data) === null || _profileData$data30 === void 0 ? void 0 : _profileData$data30.IdentityId),
                        'date': new Date() + (profileData === null || profileData === void 0 || (_profileData$data31 = profileData.data) === null || _profileData$data31 === void 0 ? void 0 : _profileData$data31.IdentityId),
                        'path': "".concat(window.location.href) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data32 = profileData.data) === null || _profileData$data32 === void 0 ? void 0 : _profileData$data32.IdentityId),
                        'mode': 'Edit',
                        'documentId': estimateResponse.payload.data.PreJobCardDocumentId,
                        'navigateTo': 'ServiceEstimate Details Jobcard Page'
                    }, profileData);
                    navigate("/serviceEstimate-details-jobCard/".concat(estimateResponse.payload.data.PreJobCardDocumentId), {
                        state: {
                            fromRoute: "/inspection-tasksDetails/".concat(documentId)
                        }
                    });
                    _a.label = 4;
                case 4: return [3 /*break*/, 7];
                case 5: return [4 /*yield*/, dispatch(setUpdatedModuleSectionByChannel([]))];
                case 6:
                    _a.sent();
                    dispatch(resetState(["documentDetailsGetById", "preDocumentFetch", "getCustomerInfo", "ModuleDetailsGetById", "additionalEstimateDetail"]));
                    // mixpanel.track(`${estimateResponse?.payload?.data?.Key}_Inspection_${handleButtonNames()}_Click` + ` / ${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` / ${profileData?.data?.IdentityId}`, {
                    //   'id': profileData?.data?.IdentityId,          // Transaction ID.
                    //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
                    //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
                    //   'date': new Date() + profileData?.data?.IdentityId,
                    //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
                    //   'mode': 'Edit',
                    //   'documentId': estimateResponse.payload.data.PreJobCardDocumentId,
                    //   'navigateTo': 'ServiceEstimate Details Page'
                    // });
                    // window.gtag(
                    //   'event', `${estimateResponse?.payload?.data?.Key}_Inspection_${handleButtonNames()}_Click`, {
                    //   'id': profileData?.data?.IdentityId,          // Transaction ID.
                    //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
                    //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
                    //   'date': new Date() + profileData?.data?.IdentityId,
                    //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
                    //   'mode': 'Edit',
                    //   'documentId': estimateResponse.payload.data.PreJobCardDocumentId,
                    //   'navigateTo': 'ServiceEstimate Details Page'
                    // });
                    transactionEventLog("".concat(estimateResponse === null || estimateResponse === void 0 || (_estimateResponse$pay7 = estimateResponse.payload) === null || _estimateResponse$pay7 === void 0 || (_estimateResponse$pay7 = _estimateResponse$pay7.data) === null || _estimateResponse$pay7 === void 0 ? void 0 : _estimateResponse$pay7.Key, "_Inspection_").concat(handleButtonNames(), "_Click"), {
                        'id': profileData === null || profileData === void 0 || (_profileData$data33 = profileData.data) === null || _profileData$data33 === void 0 ? void 0 : _profileData$data33.IdentityId,
                        // Transaction ID.
                        'name': "".concat(profileData === null || profileData === void 0 || (_profileData$data34 = profileData.data) === null || _profileData$data34 === void 0 ? void 0 : _profileData$data34.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data35 = profileData.data) === null || _profileData$data35 === void 0 ? void 0 : _profileData$data35.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data36 = profileData.data) === null || _profileData$data36 === void 0 ? void 0 : _profileData$data36.IdentityId),
                        'code': "".concat(profileData === null || profileData === void 0 || (_profileData$data37 = profileData.data) === null || _profileData$data37 === void 0 ? void 0 : _profileData$data37.Code) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data38 = profileData.data) === null || _profileData$data38 === void 0 ? void 0 : _profileData$data38.IdentityId),
                        'date': new Date() + (profileData === null || profileData === void 0 || (_profileData$data39 = profileData.data) === null || _profileData$data39 === void 0 ? void 0 : _profileData$data39.IdentityId),
                        'path': "".concat(window.location.href) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data40 = profileData.data) === null || _profileData$data40 === void 0 ? void 0 : _profileData$data40.IdentityId),
                        'mode': 'Edit',
                        'documentId': estimateResponse.payload.data.PreJobCardDocumentId,
                        'navigateTo': 'ServiceEstimate Details Page'
                    }, profileData);
                    navigate("/serviceEstimate-details/".concat(estimateResponse.payload.data.PreJobCardDocumentId), {
                        state: {
                            fromRoute: "/inspection-tasksDetails/".concat(documentId)
                        }
                    });
                    _a.label = 7;
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var VIGenerateEstimateFun = function () { return __awaiter(void 0, void 0, void 0, function () {
        var requestBody, createEstimateResponse, _profileData$data41, _profileData$data42, _profileData$data43, _profileData$data44, _profileData$data45, _profileData$data46, _profileData$data47, _profileData$data48;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        InspectionId: props.parentModuleDocumentId
                    };
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "",
                            url: createSEUrl,
                            request: requestBody
                        }))];
                case 1:
                    createEstimateResponse = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if (!(createEstimateResponse.payload.success && createEstimateResponse.payload.data.EstimateId)) return [3 /*break*/, 3];
                    return [4 /*yield*/, dispatch(setUpdatedModuleSectionByChannel([]))];
                case 2:
                    _a.sent();
                    dispatch(resetState(["documentDetailsGetById", "preDocumentFetch", "getCustomerInfo", "ModuleDetailsGetById", "additionalEstimateDetail"]));
                    dispatch(resetState(["documentDetailsGetById", "preDocumentFetch", "getCustomerInfo", "ModuleDetailsGetById", "additionalEstimateDetail"]));
                    setFinishPopup(false);
                    // mixpanel.track(`Inspection_${handleButtonNames()}_Click` + ` / ${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` / ${profileData?.data?.IdentityId}`, {
                    //   'id': profileData?.data?.IdentityId,          // Transaction ID.
                    //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
                    //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
                    //   'date': new Date() + profileData?.data?.IdentityId,
                    //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
                    //   'mode': 'Edit',
                    //   'documentId': createEstimateResponse.payload.value.data.EstimateId,
                    //   'navigateTo': 'ServiceEstimate Details Jobcard Page'
                    // });
                    // window.gtag(
                    //   'event', `Inspection_${handleButtonNames()}_Click`, {
                    //   'id': profileData?.data?.IdentityId,          // Transaction ID.
                    //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
                    //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
                    //   'date': new Date() + profileData?.data?.IdentityId,
                    //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
                    //   'mode': 'Edit',
                    //   'documentId': createEstimateResponse.payload.value.data.EstimateId,
                    //   'navigateTo': 'ServiceEstimate Details Jobcard Page'
                    // });
                    transactionEventLog("Inspection_".concat(handleButtonNames(), "_Click"), {
                        'id': profileData === null || profileData === void 0 || (_profileData$data41 = profileData.data) === null || _profileData$data41 === void 0 ? void 0 : _profileData$data41.IdentityId,
                        // Transaction ID.
                        'name': "".concat(profileData === null || profileData === void 0 || (_profileData$data42 = profileData.data) === null || _profileData$data42 === void 0 ? void 0 : _profileData$data42.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data43 = profileData.data) === null || _profileData$data43 === void 0 ? void 0 : _profileData$data43.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data44 = profileData.data) === null || _profileData$data44 === void 0 ? void 0 : _profileData$data44.IdentityId),
                        'code': "".concat(profileData === null || profileData === void 0 || (_profileData$data45 = profileData.data) === null || _profileData$data45 === void 0 ? void 0 : _profileData$data45.Code) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data46 = profileData.data) === null || _profileData$data46 === void 0 ? void 0 : _profileData$data46.IdentityId),
                        'date': new Date() + (profileData === null || profileData === void 0 || (_profileData$data47 = profileData.data) === null || _profileData$data47 === void 0 ? void 0 : _profileData$data47.IdentityId),
                        'path': "".concat(window.location.href) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data48 = profileData.data) === null || _profileData$data48 === void 0 ? void 0 : _profileData$data48.IdentityId),
                        'mode': 'Edit',
                        'documentId': createEstimateResponse.payload.data.EstimateId,
                        'navigateTo': 'ServiceEstimate Details Jobcard Page'
                    }, profileData);
                    // navigate(`/vehicleInspection-details/${props.parentModuleDocumentId}`)
                    navigate("/serviceEstimate-details/".concat(createEstimateResponse.payload.data.EstimateId, "/inspection/").concat(createEstimateResponse.payload.data.ParentId), {
                        state: {
                            fromRoute: "/inspection-tasksDetails/".concat(props.parentModuleDocumentId)
                        }
                    });
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var ConfirmAppointment = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _props$parentModuleDo, _result$payload11, _result$payload12, result, _profileData$data49, _profileData$data50, _profileData$data51, _profileData$data52, _profileData$data53, _profileData$data54, _profileData$data55, _profileData$data56;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(updateAPI({
                        key: "",
                        url: ConfirmAppointmentURL((_props$parentModuleDo = props.parentModuleDocumentId) !== null && _props$parentModuleDo !== void 0 ? _props$parentModuleDo : "")
                    }))];
                case 1:
                    result = _a.sent();
                    if ((result === null || result === void 0 || (_result$payload11 = result.payload) === null || _result$payload11 === void 0 ? void 0 : _result$payload11.statusCode) == 200 || result !== null && result !== void 0 && (_result$payload12 = result.payload) !== null && _result$payload12 !== void 0 && _result$payload12.success) {
                        if (Module === isModuleConfig.Bajaj) {
                            dispatch(resetState(["documentDetailsGetById"]));
                            // mixpanel.track(`Appointment_${handleButtonNames()}_Click` + ` / ${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` / ${profileData?.data?.IdentityId}`, {
                            //   'id': profileData?.data?.IdentityId,          // Transaction ID.
                            //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
                            //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
                            //   'date': new Date() + profileData?.data?.IdentityId,
                            //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
                            //   'mode': 'Edit',
                            //   'documentId': props.parentModuleDocumentId,
                            //   'navigateTo': 'Inspection Create Page'
                            // });
                            // window.gtag(
                            //   'event', `Appointment_${handleButtonNames()}_Click`, {
                            //   'id': profileData?.data?.IdentityId,          // Transaction ID.
                            //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
                            //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
                            //   'date': new Date() + profileData?.data?.IdentityId,
                            //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
                            //   'mode': 'Edit',
                            //   'documentId': props.parentModuleDocumentId,
                            //   'navigateTo': 'Inspection Create Page'
                            // });
                            transactionEventLog("Appointment_".concat(handleButtonNames(), "_Click"), {
                                'id': profileData === null || profileData === void 0 || (_profileData$data49 = profileData.data) === null || _profileData$data49 === void 0 ? void 0 : _profileData$data49.IdentityId,
                                // Transaction ID.
                                'name': "".concat(profileData === null || profileData === void 0 || (_profileData$data50 = profileData.data) === null || _profileData$data50 === void 0 ? void 0 : _profileData$data50.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data51 = profileData.data) === null || _profileData$data51 === void 0 ? void 0 : _profileData$data51.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data52 = profileData.data) === null || _profileData$data52 === void 0 ? void 0 : _profileData$data52.IdentityId),
                                'code': "".concat(profileData === null || profileData === void 0 || (_profileData$data53 = profileData.data) === null || _profileData$data53 === void 0 ? void 0 : _profileData$data53.Code) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data54 = profileData.data) === null || _profileData$data54 === void 0 ? void 0 : _profileData$data54.IdentityId),
                                'date': new Date() + (profileData === null || profileData === void 0 || (_profileData$data55 = profileData.data) === null || _profileData$data55 === void 0 ? void 0 : _profileData$data55.IdentityId),
                                'path': "".concat(window.location.href) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data56 = profileData.data) === null || _profileData$data56 === void 0 ? void 0 : _profileData$data56.IdentityId),
                                'mode': 'Edit',
                                'documentId': props.parentModuleDocumentId,
                                'navigateTo': 'Inspection Create Page'
                            }, profileData);
                            navigate("/create-inspection/".concat(props === null || props === void 0 ? void 0 : props.parentModuleDocumentId), {
                                state: {
                                    isFromAppointmentTaskDetails: true
                                }
                            }); //added for bajaj
                        }
                        else {
                            setOpenAptcreatePopup(true); //remove for bajaj
                        }
                        // setAptcode(result.payload.data)
                        // dispatch(showNotification({ isOpen: true, message: "Save successfully", type: "success" }))
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleClickButtons = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isValid, _profileData$data57, _profileData$data58, _profileData$data59, _profileData$data60, _profileData$data61, _profileData$data62, _profileData$data63, _profileData$data64, _documentDetailsGetBy;
        return __generator(this, function (_a) {
            isValid = validate();
            if (isValid) {
                /*
                await dispatch(createAPI({
                  key: 'syncCustomerUpdate', url: syncCustomerUpdateURL, request: {
                    CustomerId: ModuleDetailsGetById?.data?.CustomerId || documentDetailsGetById?.data?.CustomerId,
                    VinNo: ModuleDetailsGetById?.data?.VinNo || documentDetailsGetById?.data?.VinNo,
                  }
                }))
                */
                if (props.parentModuleName === EParentModuleName.ServiceEstimate) {
                    // mixpanel.track(`ServiceEstimate_${handleButtonNames()}_Click` + ` / ${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` / ${profileData?.data?.IdentityId}`, {
                    //   'id': profileData?.data?.IdentityId,          // Transaction ID.
                    //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
                    //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
                    //   'date': new Date() + profileData?.data?.IdentityId,
                    //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
                    //   'mode': 'Add/Edit',
                    //   'documentId': props.parentModuleDocumentId,
                    //   'navigateTo': 'ServiceEstimate Details Page'
                    // });
                    // window.gtag(
                    //   'event', `ServiceEstimate_${handleButtonNames()}_Click`, {
                    //   'id': profileData?.data?.IdentityId,          // Transaction ID.
                    //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
                    //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
                    //   'date': new Date() + profileData?.data?.IdentityId,
                    //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
                    //   'mode': 'Add/Edit',
                    //   'documentId': props.parentModuleDocumentId,
                    //   'navigateTo': 'ServiceEstimate Details Page'
                    // });
                    transactionEventLog("ServiceEstimate_".concat(handleButtonNames(), "_Click"), {
                        'id': profileData === null || profileData === void 0 || (_profileData$data57 = profileData.data) === null || _profileData$data57 === void 0 ? void 0 : _profileData$data57.IdentityId,
                        // Transaction ID.
                        'name': "".concat(profileData === null || profileData === void 0 || (_profileData$data58 = profileData.data) === null || _profileData$data58 === void 0 ? void 0 : _profileData$data58.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data59 = profileData.data) === null || _profileData$data59 === void 0 ? void 0 : _profileData$data59.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data60 = profileData.data) === null || _profileData$data60 === void 0 ? void 0 : _profileData$data60.IdentityId),
                        'code': "".concat(profileData === null || profileData === void 0 || (_profileData$data61 = profileData.data) === null || _profileData$data61 === void 0 ? void 0 : _profileData$data61.Code) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data62 = profileData.data) === null || _profileData$data62 === void 0 ? void 0 : _profileData$data62.IdentityId),
                        'date': new Date() + (profileData === null || profileData === void 0 || (_profileData$data63 = profileData.data) === null || _profileData$data63 === void 0 ? void 0 : _profileData$data63.IdentityId),
                        'path': "".concat(window.location.href) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data64 = profileData.data) === null || _profileData$data64 === void 0 ? void 0 : _profileData$data64.IdentityId),
                        'mode': 'Add/Edit',
                        'documentId': props.parentModuleDocumentId,
                        'navigateTo': 'ServiceEstimate Details Page'
                    }, profileData);
                    trackButtonClick("ButtonClickEvent", "Taskdetails_Generate_Estimate_Click", undefined);
                    dispatch(resetState(["documentDetailsGetById", "ModuleDetailsGetById"]));
                    dispatch(setUpdatedModuleSectionByChannel([]));
                    navigate("/serviceEstimate-details/".concat(props.parentModuleDocumentId));
                }
                if (props.parentModuleName === EParentModuleName.Appointment) {
                    trackButtonClick("ButtonClickEvent", "Appointment_Confirm_Click", undefined);
                    ConfirmAppointment();
                    if (Module === isModuleConfig.Product) {
                        setOpenAptcreatePopup(true);
                    }
                }
                if (props.parentModuleName === EParentModuleName.Inspection) {
                    trackButtonClick("ButtonClickEvent", "Taskdetails_Generate_Estimate_Click", undefined);
                    dispatch(resetState(["documentDetailsGetById", "ModuleDetailsGetById"]));
                    if (createAndEditFlow.isInspection == "Update") {
                        if ((documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy = documentDetailsGetById.data) === null || _documentDetailsGetBy === void 0 ? void 0 : _documentDetailsGetBy.Key) == "Closed") {
                            viewEstimateFun();
                        }
                        else {
                            completeInspectionFun();
                        }
                    }
                    else {
                        completeInspectionFun();
                    }
                    // completeInspectionFun()
                }
                // buttonClickSpan.end();
                // pageLoadSpan.end();
                // transaction.end();
                dispatch(setIsTaskDetailsDataUpdated(false));
                dispatch(setTaskDetailsDataSaved(false));
                dispatch(setTaskDetailsToggleValue({
                    roadTestToggle: false,
                    periodicMaintenanceToggle: false,
                    standardJobsToggle: false,
                    additionalJobsToggle: false,
                    preCheckToggle: false
                }));
            }
            return [2 /*return*/];
        });
    }); };
    var validate = function () {
        var isSaved = [];
        var validateMessage = "";
        if (props.isFromAppointmentTask) {
            if (!((getSavedTaskDetailsCount === null || getSavedTaskDetailsCount === void 0 ? void 0 : getSavedTaskDetailsCount.periodicMaintenanceCount) !== 0 || (getModuleHeaderCount === null || getModuleHeaderCount === void 0 ? void 0 : getModuleHeaderCount.PeriodicParts) !== 0 || (getSavedTaskDetailsCount === null || getSavedTaskDetailsCount === void 0 ? void 0 : getSavedTaskDetailsCount.standardJobsCount) !== 0 || (getModuleHeaderCount === null || getModuleHeaderCount === void 0 ? void 0 : getModuleHeaderCount.StandardParts) !== 0)) {
                if (getModuleHeaderCount.jobItems === 0) {
                    GoogleAnlyticsErrorLog(profileData, 'ClientSide', 'Please select atleast 1 job items');
                    dispatch(showNotification({
                        isOpen: true,
                        message: "Please select atleast 1 job items",
                        type: "error"
                    }));
                    return false;
                }
            }
        }
        updatedModuleSectionByChannel.map(function (item) {
            var _item$SectionAttribut4, _item$SectionAttribut5, _item$SectionAttribut6, _item$SectionAttribut8, _item$SectionAttribut9, _item$SectionAttribut10, _item$SectionAttribut11, _item$SectionAttribut12, _item$SectionAttribut13, _item$SectionAttribut14, _item$SectionAttribut15, _item$SectionAttribut16, _item$SectionAttribut17, _item$SectionAttribut18;
            if (props.isFromAppointmentTask) {
                var _item$SectionAttribut3;
                validateMessage = "Please select atleast ".concat(item === null || item === void 0 || (_item$SectionAttribut3 = item.SectionAttributes[0]) === null || _item$SectionAttribut3 === void 0 ? void 0 : _item$SectionAttribut3.Count, " records of ").concat(item === null || item === void 0 ? void 0 : item.DisplayName);
                switch (item === null || item === void 0 ? void 0 : item.Key) {
                    case EModuleSection.PeriodicMaintenance:
                        if (item !== null && item !== void 0 && (_item$SectionAttribut4 = item.SectionAttributes[0]) !== null && _item$SectionAttribut4 !== void 0 && _item$SectionAttribut4.MANDATORY) {
                            if (productWisePmsList.length > 0) {
                                if ((getModuleHeaderCount.PeriodicParts > 0 || getModuleHeaderCount.CustomerDeclinedJobs > 0) && !(getModuleHeaderCount.PeriodicParts === 0 && getModuleHeaderCount.CustomerDeclinedJobs === 0)) {
                                    isSaved.push("true");
                                }
                                else {
                                    if (TaskDetailsSectionSave !== null && TaskDetailsSectionSave !== void 0 && TaskDetailsSectionSave.periodicMaintainance) {
                                        isSaved.push("true");
                                    }
                                    else {
                                        isSaved.push("false");
                                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', t("PM_PARTS_MANDATORY_MSG", {
                                            displayName: item === null || item === void 0 ? void 0 : item.DisplayName
                                        }));
                                        dispatch(showNotification({
                                            isOpen: true,
                                            message: t("PM_PARTS_MANDATORY_MSG", {
                                                displayName: item === null || item === void 0 ? void 0 : item.DisplayName
                                            }),
                                            type: "error"
                                        }));
                                    }
                                }
                            }
                            else {
                                isSaved.push("true");
                            }
                        }
                        else {
                            isSaved.push("true");
                        }
                        break;
                    case EModuleSection.StandardJobs:
                        if (item !== null && item !== void 0 && (_item$SectionAttribut5 = item.SectionAttributes[0]) !== null && _item$SectionAttribut5 !== void 0 && _item$SectionAttribut5.MANDATORY && (item === null || item === void 0 || (_item$SectionAttribut6 = item.SectionAttributes[0]) === null || _item$SectionAttribut6 === void 0 ? void 0 : _item$SectionAttribut6.Count) > (getSavedTaskDetailsCount === null || getSavedTaskDetailsCount === void 0 ? void 0 : getSavedTaskDetailsCount.standardJobsCount)) {
                            GoogleAnlyticsErrorLog(profileData, 'ClientSide', validateMessage);
                            dispatch(showNotification({
                                isOpen: true,
                                message: validateMessage,
                                type: "error"
                            }));
                            isSaved.push("false");
                        }
                        else {
                            isSaved.push("true");
                        }
                        break;
                    default:
                        isSaved.push("true");
                        break;
                }
            }
            else {
                var _item$SectionAttribut7;
                validateMessage = "Please select atleast ".concat(item === null || item === void 0 || (_item$SectionAttribut7 = item.SectionAttributes[0]) === null || _item$SectionAttribut7 === void 0 ? void 0 : _item$SectionAttribut7.Count, " records of ").concat(item.DisplayName);
                switch (item.Key) {
                    case EModuleSection.PeriodicMaintenance:
                        if (item !== null && item !== void 0 && (_item$SectionAttribut8 = item.SectionAttributes[0]) !== null && _item$SectionAttribut8 !== void 0 && _item$SectionAttribut8.MANDATORY) {
                            if (productWisePmsList.length > 0) {
                                if ((getModuleHeaderCount.PeriodicParts > 0 || getModuleHeaderCount.CustomerDeclinedJobs > 0) && !(getModuleHeaderCount.PeriodicParts === 0 && getModuleHeaderCount.CustomerDeclinedJobs === 0)) {
                                    isSaved.push("true");
                                }
                                else {
                                    if (TaskDetailsSectionSave !== null && TaskDetailsSectionSave !== void 0 && TaskDetailsSectionSave.periodicMaintainance) {
                                        isSaved.push("true");
                                    }
                                    else {
                                        isSaved.push("false");
                                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', t("PM_PARTS_MANDATORY_MSG", {
                                            displayName: item === null || item === void 0 ? void 0 : item.DisplayName
                                        }));
                                        dispatch(showNotification({
                                            isOpen: true,
                                            message: t("PM_PARTS_MANDATORY_MSG", {
                                                displayName: item === null || item === void 0 ? void 0 : item.DisplayName
                                            }),
                                            type: "error"
                                        }));
                                    }
                                }
                            }
                            else {
                                isSaved.push("true");
                            }
                        }
                        else {
                            isSaved.push("true");
                        }
                        break;
                    case EModuleSection.StandardJobs:
                        if (item !== null && item !== void 0 && (_item$SectionAttribut9 = item.SectionAttributes[0]) !== null && _item$SectionAttribut9 !== void 0 && _item$SectionAttribut9.MANDATORY && (item === null || item === void 0 || (_item$SectionAttribut10 = item.SectionAttributes[0]) === null || _item$SectionAttribut10 === void 0 ? void 0 : _item$SectionAttribut10.Count) > (getSavedTaskDetailsCount === null || getSavedTaskDetailsCount === void 0 ? void 0 : getSavedTaskDetailsCount.standardJobsCount)) {
                            GoogleAnlyticsErrorLog(profileData, 'ClientSide', validateMessage);
                            dispatch(showNotification({
                                isOpen: true,
                                message: validateMessage,
                                type: "error"
                            }));
                            isSaved.push("false");
                        }
                        else {
                            isSaved.push("true");
                        }
                        break;
                    case EModuleSection.Precheck:
                        if (item !== null && item !== void 0 && (_item$SectionAttribut11 = item.SectionAttributes[0]) !== null && _item$SectionAttribut11 !== void 0 && _item$SectionAttribut11.MANDATORY && (item === null || item === void 0 || (_item$SectionAttribut12 = item.SectionAttributes[0]) === null || _item$SectionAttribut12 === void 0 ? void 0 : _item$SectionAttribut12.Count) > (getSavedTaskDetailsCount === null || getSavedTaskDetailsCount === void 0 ? void 0 : getSavedTaskDetailsCount.preCheckCount)) {
                            GoogleAnlyticsErrorLog(profileData, 'ClientSide', validateMessage);
                            dispatch(showNotification({
                                isOpen: true,
                                message: validateMessage,
                                type: "error"
                            }));
                            isSaved.push("false");
                        }
                        else if (checkAllFuelIndicatorValuesEmpty()) {
                            console.log("fuelIndicatorSaved11111111", fuelIndicatorSaved);
                            if (!fuelIndicatorSaved) {
                                GoogleAnlyticsErrorLog(profileData, 'ClientSide', "Please mark fuel/battery level");
                                dispatch(showNotification({
                                    isOpen: true,
                                    message: "Please mark fuel/battery level",
                                    type: "error"
                                }));
                                isSaved.push("false");
                            }
                            else {
                                isSaved.push("true");
                            }
                        }
                        else {
                            // Check fuel indicator validation
                            if (fuelIdicatorDynamicListTaskDetails.length > 0) {
                                var _fuelIdicatorDynamicL2;
                                // Check if any fuel indicator has empty ResponseValue (from API or local)
                                var hasEmptyValue = (_fuelIdicatorDynamicL2 = fuelIdicatorDynamicListTaskDetails[0].Questions) === null || _fuelIdicatorDynamicL2 === void 0 ? void 0 : _fuelIdicatorDynamicL2.some(function (item) { return item.ResponseValue === "" || item.ResponseValue === null || item.ResponseValue === undefined; });
                                if (hasEmptyValue) {
                                    // If ResponseValue is empty string, null, or undefined, show "Please mark fuel/battery level"
                                    GoogleAnlyticsErrorLog(profileData, 'ClientSide', "Please mark fuel/battery level");
                                    dispatch(showNotification({
                                        isOpen: true,
                                        message: "Please mark fuel/battery level",
                                        type: "error"
                                    }));
                                    isSaved.push("false");
                                }
                                else if (!fuelIndicatorSaved && isFuelIndicatorSliderChanged) {
                                    // If fuelIndicatorSaved is false, it means there are unsaved local changes
                                    GoogleAnlyticsErrorLog(profileData, 'ClientSide', "Please save fuel/battery level changes");
                                    dispatch(showNotification({
                                        isOpen: true,
                                        message: "Please save fuel/battery level changes",
                                        type: "error"
                                    }));
                                    isSaved.push("false");
                                }
                                else {
                                    // If ResponseValue has a value (including "0") and fuelIndicatorSaved is true, allow saving
                                    isSaved.push("true");
                                }
                            }
                            else {
                                isSaved.push("true");
                            }
                        }
                        break;
                    case EModuleSection.AdditionalJobs:
                        if (item !== null && item !== void 0 && (_item$SectionAttribut13 = item.SectionAttributes[0]) !== null && _item$SectionAttribut13 !== void 0 && _item$SectionAttribut13.MANDATORY && (item === null || item === void 0 || (_item$SectionAttribut14 = item.SectionAttributes[0]) === null || _item$SectionAttribut14 === void 0 ? void 0 : _item$SectionAttribut14.Count) > (getSavedTaskDetailsCount === null || getSavedTaskDetailsCount === void 0 ? void 0 : getSavedTaskDetailsCount.additionalJobsCount)) {
                            GoogleAnlyticsErrorLog(profileData, 'ClientSide', validateMessage);
                            dispatch(showNotification({
                                isOpen: true,
                                message: validateMessage,
                                type: "error"
                            }));
                            isSaved.push("false");
                        }
                        else {
                            isSaved.push("true");
                        }
                        break;
                    case EModuleSection.AdvisorSuggestions:
                        console.log("getSavedTaskDetailsCount?.advisorSuggestionsCount", getSavedTaskDetailsCount === null || getSavedTaskDetailsCount === void 0 ? void 0 : getSavedTaskDetailsCount.advisorSuggestionsCount);
                        if (item !== null && item !== void 0 && (_item$SectionAttribut15 = item.SectionAttributes[0]) !== null && _item$SectionAttribut15 !== void 0 && _item$SectionAttribut15.MANDATORY && Number(item === null || item === void 0 || (_item$SectionAttribut16 = item.SectionAttributes[0]) === null || _item$SectionAttribut16 === void 0 ? void 0 : _item$SectionAttribut16.Count) > Number(getSavedTaskDetailsCount === null || getSavedTaskDetailsCount === void 0 ? void 0 : getSavedTaskDetailsCount.advisorSuggestionsCount)) {
                            GoogleAnlyticsErrorLog(profileData, 'ClientSide', validateMessage);
                            dispatch(showNotification({
                                isOpen: true,
                                message: validateMessage,
                                type: "error"
                            }));
                            isSaved.push("false");
                        }
                        else {
                            isSaved.push("true");
                        }
                        break;
                    case EModuleSection.FutureAdvise:
                        if (item !== null && item !== void 0 && (_item$SectionAttribut17 = item.SectionAttributes[0]) !== null && _item$SectionAttribut17 !== void 0 && _item$SectionAttribut17.MANDATORY && Number(item === null || item === void 0 || (_item$SectionAttribut18 = item.SectionAttributes[0]) === null || _item$SectionAttribut18 === void 0 ? void 0 : _item$SectionAttribut18.Count) > Number(getSavedTaskDetailsCount === null || getSavedTaskDetailsCount === void 0 ? void 0 : getSavedTaskDetailsCount.futureAdviseCount)) {
                            GoogleAnlyticsErrorLog(profileData, 'ClientSide', validateMessage);
                            dispatch(showNotification({
                                isOpen: true,
                                message: validateMessage,
                                type: "error"
                            }));
                            isSaved.push("false");
                        }
                        else {
                            isSaved.push("true");
                        }
                        break;
                    default:
                        isSaved.push("true");
                        break;
                }
            }
        });
        var all_true = isSaved.every(function (item) { return item === "true"; });
        return all_true;
    };
    var completeInspectionFun = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _ModuleDetailsGetById30, _props$parentModuleDo2, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!((ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById30 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById30 === void 0 ? void 0 : _ModuleDetailsGetById30.Key) === StatusEnum.Converted)) return [3 /*break*/, 1];
                    modifyAndCloneEstimate();
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, dispatch(updateAPI({
                        key: "",
                        url: getCompleteInspectionUrl((_props$parentModuleDo2 = props.parentModuleDocumentId) !== null && _props$parentModuleDo2 !== void 0 ? _props$parentModuleDo2 : "")
                    }))];
                case 2:
                    response = _a.sent();
                    if (response.payload.success && response.payload.data) {
                        if (Module === isModuleConfig.Bajaj) {
                            VIGenerateEstimateFun();
                        }
                        else {
                            setFinishPopup(true);
                        }
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var viewEstimateFun = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload13, _result$payload14, requestBody, result, _profileData$data65, _profileData$data66, _profileData$data67, _profileData$data68, _profileData$data69, _profileData$data70, _profileData$data71, _profileData$data72, _result$payload15, _result$payload16;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        PreJobCardDocumentId: inspectionId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: ViewEstimateUrl,
                            request: requestBody
                        }))];
                case 1:
                    result = _a.sent();
                    if (result !== null && result !== void 0 && (_result$payload13 = result.payload) !== null && _result$payload13 !== void 0 && _result$payload13.success && (result === null || result === void 0 || (_result$payload14 = result.payload) === null || _result$payload14 === void 0 ? void 0 : _result$payload14.statusCode) == 200) {
                        // mixpanel.track(`Inspection_${handleButtonNames()}_Click` + ` / ${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` / ${profileData?.data?.IdentityId}`, {
                        //   'id': profileData?.data?.IdentityId,          // Transaction ID.
                        //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
                        //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
                        //   'date': new Date() + profileData?.data?.IdentityId,
                        //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
                        //   'mode': 'View',
                        //   'documentId': result?.payload?.data?.id,
                        //   'navigateTo': 'ServiceEstimate Details Page'
                        // });
                        // window.gtag(
                        //   'event', `Inspection_${handleButtonNames()}_Click`, {
                        //   'id': profileData?.data?.IdentityId,          // Transaction ID.
                        //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
                        //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
                        //   'date': new Date() + profileData?.data?.IdentityId,
                        //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
                        //   'mode': 'View',
                        //   'documentId': result?.payload?.data?.id,
                        //   'navigateTo': 'ServiceEstimate Details Page'
                        // });
                        transactionEventLog("Inspection_".concat(handleButtonNames(), "_Click"), {
                            'id': profileData === null || profileData === void 0 || (_profileData$data65 = profileData.data) === null || _profileData$data65 === void 0 ? void 0 : _profileData$data65.IdentityId,
                            // Transaction ID.
                            'name': "".concat(profileData === null || profileData === void 0 || (_profileData$data66 = profileData.data) === null || _profileData$data66 === void 0 ? void 0 : _profileData$data66.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data67 = profileData.data) === null || _profileData$data67 === void 0 ? void 0 : _profileData$data67.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data68 = profileData.data) === null || _profileData$data68 === void 0 ? void 0 : _profileData$data68.IdentityId),
                            'code': "".concat(profileData === null || profileData === void 0 || (_profileData$data69 = profileData.data) === null || _profileData$data69 === void 0 ? void 0 : _profileData$data69.Code) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data70 = profileData.data) === null || _profileData$data70 === void 0 ? void 0 : _profileData$data70.IdentityId),
                            'date': new Date() + (profileData === null || profileData === void 0 || (_profileData$data71 = profileData.data) === null || _profileData$data71 === void 0 ? void 0 : _profileData$data71.IdentityId),
                            'path': "".concat(window.location.href) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data72 = profileData.data) === null || _profileData$data72 === void 0 ? void 0 : _profileData$data72.IdentityId),
                            'mode': 'View',
                            'documentId': result === null || result === void 0 || (_result$payload15 = result.payload) === null || _result$payload15 === void 0 || (_result$payload15 = _result$payload15.data) === null || _result$payload15 === void 0 ? void 0 : _result$payload15.id,
                            'navigateTo': 'ServiceEstimate Details Page'
                        }, profileData);
                        navigate("/serviceEstimate-details/".concat(result === null || result === void 0 || (_result$payload16 = result.payload) === null || _result$payload16 === void 0 || (_result$payload16 = _result$payload16.data) === null || _result$payload16 === void 0 ? void 0 : _result$payload16.id));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleCancelPopup = function () {
        navigate("/appointment");
    };
    var getDisabled = function () {
        var disableValue = false;
        if (updatedModuleSectionByChannel.length > 0) {
            updatedModuleSectionByChannel.map(function (item) {
                var _item$SectionAttribut19, _item$SectionAttribut20, _item$SectionAttribut21, _item$SectionAttribut22, _item$SectionAttribut23, _item$SectionAttribut24, _item$SectionAttribut25, _item$SectionAttribut26, _item$SectionAttribut27, _item$SectionAttribut28, _item$SectionAttribut29, _item$SectionAttribut30;
                if (props.isFromAppointmentTask) {
                    switch (item.Key) {
                        case EModuleSection.PeriodicMaintenance:
                            if (item !== null && item !== void 0 && item.SectionAttributes && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && item !== null && item !== void 0 && (_item$SectionAttribut19 = item.SectionAttributes[0]) !== null && _item$SectionAttribut19 !== void 0 && _item$SectionAttribut19.MANDATORY && (item === null || item === void 0 || (_item$SectionAttribut20 = item.SectionAttributes[0]) === null || _item$SectionAttribut20 === void 0 ? void 0 : _item$SectionAttribut20.Count) > (getSavedTaskDetailsCount === null || getSavedTaskDetailsCount === void 0 ? void 0 : getSavedTaskDetailsCount.periodicMaintenanceCount)) {
                                disableValue = true;
                            }
                            break;
                        case EModuleSection.StandardJobs:
                            if (item !== null && item !== void 0 && (_item$SectionAttribut21 = item.SectionAttributes[0]) !== null && _item$SectionAttribut21 !== void 0 && _item$SectionAttribut21.MANDATORY && (item === null || item === void 0 || (_item$SectionAttribut22 = item.SectionAttributes[0]) === null || _item$SectionAttribut22 === void 0 ? void 0 : _item$SectionAttribut22.Count) > (getSavedTaskDetailsCount === null || getSavedTaskDetailsCount === void 0 ? void 0 : getSavedTaskDetailsCount.standardJobsCount)) {
                                disableValue = true;
                            }
                            break;
                        default:
                            disableValue = false;
                            break;
                    }
                }
                else {
                    switch (item.Key) {
                        case EModuleSection.PeriodicMaintenance:
                            if (item !== null && item !== void 0 && (_item$SectionAttribut23 = item.SectionAttributes[0]) !== null && _item$SectionAttribut23 !== void 0 && _item$SectionAttribut23.MANDATORY && (item === null || item === void 0 || (_item$SectionAttribut24 = item.SectionAttributes[0]) === null || _item$SectionAttribut24 === void 0 ? void 0 : _item$SectionAttribut24.Count) > (getSavedTaskDetailsCount === null || getSavedTaskDetailsCount === void 0 ? void 0 : getSavedTaskDetailsCount.periodicMaintenanceCount)) {
                                disableValue = true;
                            }
                            break;
                        case EModuleSection.StandardJobs:
                            if (item !== null && item !== void 0 && (_item$SectionAttribut25 = item.SectionAttributes[0]) !== null && _item$SectionAttribut25 !== void 0 && _item$SectionAttribut25.MANDATORY && (item === null || item === void 0 || (_item$SectionAttribut26 = item.SectionAttributes[0]) === null || _item$SectionAttribut26 === void 0 ? void 0 : _item$SectionAttribut26.Count) > (getSavedTaskDetailsCount === null || getSavedTaskDetailsCount === void 0 ? void 0 : getSavedTaskDetailsCount.standardJobsCount)) {
                                disableValue = true;
                            }
                            break;
                        case EModuleSection.Precheck:
                            if (item !== null && item !== void 0 && (_item$SectionAttribut27 = item.SectionAttributes[0]) !== null && _item$SectionAttribut27 !== void 0 && _item$SectionAttribut27.MANDATORY && (item === null || item === void 0 || (_item$SectionAttribut28 = item.SectionAttributes[0]) === null || _item$SectionAttribut28 === void 0 ? void 0 : _item$SectionAttribut28.Count) > (getSavedTaskDetailsCount === null || getSavedTaskDetailsCount === void 0 ? void 0 : getSavedTaskDetailsCount.preCheckCount)) {
                                disableValue = true;
                            }
                            break;
                        case EModuleSection.AdditionalJobs:
                            if (item !== null && item !== void 0 && (_item$SectionAttribut29 = item.SectionAttributes[0]) !== null && _item$SectionAttribut29 !== void 0 && _item$SectionAttribut29.MANDATORY && (item === null || item === void 0 || (_item$SectionAttribut30 = item.SectionAttributes[0]) === null || _item$SectionAttribut30 === void 0 ? void 0 : _item$SectionAttribut30.Count) > (getSavedTaskDetailsCount === null || getSavedTaskDetailsCount === void 0 ? void 0 : getSavedTaskDetailsCount.additionalJobsCount)) {
                                disableValue = true;
                            }
                            break;
                        default:
                            disableValue = false;
                            break;
                    }
                }
            });
        }
        else {
            disableValue = true;
        }
        dispatch(setTasksDetailsIsDisable(disableValue));
        //setGetDisableValue(disableValue)
        //return disableValue
    };
    var handleVIFinishYesButton = function () {
        trackButtonClick("ButtonClickEvent", "FinishInspectionClick", undefined);
        VIGenerateEstimateFun();
    };
    var handleVIFinishNoButton = function () {
        setFinishPopup(false);
        navigate("/inspection");
    };
    var handleButtonNames = function () {
        if (props.parentModuleName === EParentModuleName.Appointment) {
            return t("TASK_DETAILS_APPOINMENT_BTN");
        }
        else if (props.parentModuleName === EParentModuleName.Inspection) {
            if (createAndEditFlow.isInspection == "Update") {
                var _ModuleDetailsGetById31, _ModuleDetailsGetById32, _ModuleDetailsGetById33, _ModuleDetailsGetById34;
                if ((ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById31 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById31 === void 0 ? void 0 : _ModuleDetailsGetById31.Key) == "Completed") {
                    return t("TASK_DETAILS_GENERATE_ESTIMATE_BTN");
                }
                else if ((ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById32 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById32 === void 0 ? void 0 : _ModuleDetailsGetById32.Key) == "Open" || (ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById33 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById33 === void 0 ? void 0 : _ModuleDetailsGetById33.Key) == StatusEnum.Converted) {
                    return t("TASK_DETAILS_FINISH_INSEPCTION_BTN");
                }
                else if ((ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById34 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById34 === void 0 ? void 0 : _ModuleDetailsGetById34.Key) == "Closed") {
                    return t("TASK_DETAILS_VIEW_ESTIMATE_BTN");
                }
            }
            return t("TASK_DETAILS_FINISH_INSEPCTION_BTN");
        }
        else if (props.parentModuleName === EParentModuleName.ServiceEstimate) {
            return t("TASK_DETAILS_GENERATE_ESTIMATE_BTN");
        }
    };
    var checkPerformAll = function () { };
    var handleAccordianClick = function (value, key) {
        var updatedList = updatedModuleSectionByChannel === null || updatedModuleSectionByChannel === void 0 ? void 0 : updatedModuleSectionByChannel.map(function (item) { return item.Key == key ? _objectSpread(_objectSpread({}, item), {}, {
            isAccordianOpen: value
        }) : _objectSpread(_objectSpread({}, item), {}, {
            isAccordianOpen: false
        }); });
        setIsExpanded(value);
        dispatch(setUpdatedModuleSectionByChannel(updatedList));
        setExpanded(!expanded);
    };
    var DisableTaskDetailButtons = function () {
        if (props.isDisabled || updatedModuleSectionByChannel.length == 0 || props.parentModuleName !== EParentModuleName.Appointment && !taskDetailDataSaved) {
            var _documentDetailsGetBy2;
            if (props.parentModuleName === EParentModuleName.Inspection && (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy2 = documentDetailsGetById.data) === null || _documentDetailsGetBy2 === void 0 ? void 0 : _documentDetailsGetBy2.Key) == 'Closed') {
                return false;
            }
            return true;
        }
        else {
            return false;
        }
    };
    var onPreviousDeclineJobClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var updatedList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    trackButtonClick("ButtonClickEvent", "Previous_Declined_Jobs_Click", undefined);
                    setPeriodicMaintainanceApiCall(false);
                    setAddiotionalJobApiCall(false);
                    setPrecheckApiCall(false);
                    setRoadTestApiCall(false);
                    setCallApi(false);
                    if (updatedModuleSectionByChannel && updatedModuleSectionByChannel.length > 0) {
                        updatedList = updatedModuleSectionByChannel === null || updatedModuleSectionByChannel === void 0 ? void 0 : updatedModuleSectionByChannel.map(function (item) {
                            return _objectSpread(_objectSpread({}, item), {}, {
                                isAccordianOpen: false
                            });
                        });
                        dispatch(setUpdatedModuleSectionByChannel(updatedList));
                    }
                    setPreviousDeclinedLoader(true);
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, SetPrevDeclineConfig()];
                case 1:
                    _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    setPreviousDeclinedLoader(false);
                    setOpenPreviousDeclinePopup(true);
                    return [2 /*return*/];
            }
        });
    }); };
    var onClosePreviouslyDeclinedPopup = function () {
        if (!props.isDisabled) {
            dispatch(resetState(["savedStandardJobs", 'StandaredJobList', 'getSearchTypeList', 'getDeclineStandardJobs']));
            setJobCount({});
            getCountModuleWise({});
        }
        setOpenPreviousDeclinePopup(false);
    };
    var findHeader = function (module) {
        switch (module) {
            case EParentModuleName.Jobcard:
                return 'Job Card';
            case EParentModuleName.ServiceEstimate:
                return 'Service Estimate';
            case EParentModuleName.Appointment:
                return 'Appointment';
            case EParentModuleName.Inspection:
                return t('Inspection');
            default:
                return 'Job Card';
        }
    };
    var showRepeatItems = function (repeatItems, savedItems) {
        var updatedRepeatedItems = [];
        repeatItems.map(function (item) {
            var findItem = savedItems.find(function (savedItem) { return savedItem.ChildId === item.ChildId; });
            if (findItem) {
                updatedRepeatedItems.push(_objectSpread(_objectSpread({}, item), findItem));
            }
        });
        if (updatedRepeatedItems.length > 0) {
            setRepeatJobItemsDetails(updatedRepeatedItems);
            setShowRepeatAlertsPopup(true);
        }
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        width: "100%",
        marginBottom: 9
    }, /*#__PURE__*/ React.createElement(HeaderDetails, {
        headerTitle: findHeader(parentModuleName),
        status: (_ModuleDetailsGetById35 = ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById36 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById36 === void 0 ? void 0 : _ModuleDetailsGetById36.StatusName) !== null && _ModuleDetailsGetById35 !== void 0 ? _ModuleDetailsGetById35 : "",
        docDate: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById37 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById37 === void 0 ? void 0 : _ModuleDetailsGetById37.CreatedOn,
        docNo: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById38 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById38 === void 0 ? void 0 : _ModuleDetailsGetById38.Code,
        sourceDocumentNo: ModuleDetailsGetById !== null && ModuleDetailsGetById !== void 0 && (_ModuleDetailsGetById39 = ModuleDetailsGetById.data) !== null && _ModuleDetailsGetById39 !== void 0 && _ModuleDetailsGetById39.SourceDocumentNo ? ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById40 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById40 === void 0 ? void 0 : _ModuleDetailsGetById40.SourceDocumentNo : "",
        onHandleClick: onClickBackArrow,
        onMoreIconClick: function (event) { },
        isFromAppointment: false,
        parentComponent: parentModuleName,
        statusKey: ''
        // onClickJobCardStatusProgress={onClickStatusStepperIcon}
    }), (ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 ? void 0 : ModuleDetailsGetById.data) && /*#__PURE__*/ React.createElement(OptionAlert, {
        documentStatusKey: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById41 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById41 === void 0 ? void 0 : _ModuleDetailsGetById41.Key,
        jobCardId: documentId !== null && documentId !== void 0 ? documentId : "",
        JobcardNo: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById42 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById42 === void 0 ? void 0 : _ModuleDetailsGetById42.JobCardNo,
        difference: ModuleDetailsGetById !== null && ModuleDetailsGetById !== void 0 && (_ModuleDetailsGetById43 = ModuleDetailsGetById.data) !== null && _ModuleDetailsGetById43 !== void 0 && _ModuleDetailsGetById43.EstimateDeliveryDateTime ? moment().diff(moment(ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById44 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById44 === void 0 ? void 0 : _ModuleDetailsGetById44.EstimateDeliveryDateTime), 'minutes') : 0,
        EstimatedDateTime: ModuleDetailsGetById !== null && ModuleDetailsGetById !== void 0 && (_ModuleDetailsGetById45 = ModuleDetailsGetById.data) !== null && _ModuleDetailsGetById45 !== void 0 && _ModuleDetailsGetById45.EstimateDeliveryDateTime ? moment(ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById46 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById46 === void 0 ? void 0 : _ModuleDetailsGetById46.EstimateDeliveryDateTime).format('DD MMM, YYYY - h:mm A') : "",
        previousJobcard: previousJobcardRepeat,
        InstallBaseId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById47 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById47 === void 0 ? void 0 : _ModuleDetailsGetById47.InstallBaseId,
        isCreateDocumentFlow: false,
        isDocumentDisabled: props.isDisabled
    }), /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12,
        paddingX: 2,
        lg: 12,
        xl: 12,
        p: 2
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            border: "1px solid ".concat(systemColor.grey),
            marginRight: '-15px',
            marginLeft: '-15px'
        }
    }))), /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 8,
        lg: 8,
        ref: contentRef
    }, ModuleDetailsGetById.data ? /*#__PURE__*/ React.createElement(React.Fragment, null, renderPreviousDeclineJob && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        gap: 1,
        px: 2,
        pb: 1,
        sm: 12,
        md: 12,
        lg: 12,
        alignItems: "center",
        display: "flex",
        justifyContent: "flex-end"
    }, previousDeclinedLoader ? /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        style: {
            height: '20px',
            width: "140px"
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null))) : /*#__PURE__*/ React.createElement(MuiButton, {
        variant: "text",
        endIcon: /*#__PURE__*/ React.createElement(ChevronRightIcon, null),
        name: "Prev. declined jobs",
        size: "small",
        sx: {
            backgroundColor: 'transparent'
        },
        onClick: onPreviousDeclineJobClick,
        id: "Prev-declined-jobs"
    })), Module === isModuleConfig.Product && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 11.8,
        lg: 11.8
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        style: {
            display: "flex",
            justifyContent: "flex-end",
            paddingRight: 10
        }
    }, /*#__PURE__*/ React.createElement(FormControlLabel, {
        value: "start",
        checked: allswitchEnabled,
        control: /*#__PURE__*/ React.createElement(IOSSwitch, {
            id: "perform-all-toggle",
            color: "primary",
            sx: {
                marginTop: 1,
                margin: 1,
                mr: 3
            }
        }),
        label: t("Perform all"),
        labelPlacement: "start",
        onChange: handleAllSwitchButtonState
    }))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 11.8,
        lg: 11.8
    }, updatedModuleSectionByChannel && updatedModuleSectionByChannel.length > 0 ? updatedModuleSectionByChannel.length > 0 ? updatedModuleSectionByChannel.map(function (item) {
        var _item$SectionAttribut31, _item$SectionAttribut32, _item$SectionAttribut33, _item$SectionAttribut34, _item$SectionAttribut35, _item$SectionAttribut36, _item$SectionAttribut37, _item$SectionAttribut38, _item$SectionAttribut39, _item$SectionAttribut40, _item$SectionAttribut41, _item$SectionAttribut42, _item$SectionAttribut43, _item$SectionAttribut44;
        return (item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.PeriodicMaintenance && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut31 = item.SectionAttributes[0]) !== null && _item$SectionAttribut31 !== void 0 && _item$SectionAttribut31.HIDE) ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            padding: "8px 16px 8px 16px"
        }, item === null || item === void 0 || (_item$SectionAttribut32 = item.SectionAttributes) === null || _item$SectionAttribut32 === void 0 ? void 0 : _item$SectionAttribut32.map(function (elem, accordianIndex) {
            var _props$upsertPMPartsU, _props$SystemName;
            return !elem.HIDE ? /*#__PURE__*/ React.createElement(CustomeAccordianWithButton, {
                isMandatory: (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && Module === isModuleConfig.Bajaj,
                key: accordianIndex,
                title: item === null || item === void 0 ? void 0 : item.DisplayName,
                id: item === null || item === void 0 ? void 0 : item.DisplayName,
                KeyForId: "TASK_DETAILS_" + (item === null || item === void 0 ? void 0 : item.Key),
                switchButtonsEnabled: allswitchEnabled || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
                isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
                handleClick: function () {
                    setPeriodicMaintainanceApiCall(true);
                },
                isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
                handleAccordianClick: function (value) { return handleAccordianClick(value, EModuleSection.PeriodicMaintenance); },
                selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || getTaskDetailsToggleValue.periodicMaintenanceToggle || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
                listLength: getModuleHeaderCount === null || getModuleHeaderCount === void 0 ? void 0 : getModuleHeaderCount.PeriodicParts,
                countVisible: true,
                declinejobCountVisible: (getModuleHeaderCount === null || getModuleHeaderCount === void 0 ? void 0 : getModuleHeaderCount.CustomerDeclinedJobs) > 0,
                declineJobLength: getModuleHeaderCount === null || getModuleHeaderCount === void 0 ? void 0 : getModuleHeaderCount.CustomerDeclinedJobs
            }, /*#__PURE__*/ React.createElement(PeriodicMaintainanceComponent, {
                isSkeleton: isSkeleton,
                setIsSkeleton: setIsSkeleton,
                pmPartsList: pmPartsList,
                setPmPartsMasterList: setPmPartsMasterList,
                setRejectReasonRemarkList: setRejectReasonRemarkList,
                setpmPartsList: setpmPartsList,
                declinedPmPartsList: declinedPmPartsList,
                pmPartsMasterList: pmPartsMasterList,
                rejectReasonRemarkList: rejectReasonRemarkList,
                setDeclinedPmPartsList: setDeclinedPmPartsList,
                parentModuleName: props.parentModuleName,
                getSavedPeriodicPartsUrl: props.getSavedPeriodicPartsUrl,
                upsertPMPartsUrl: (_props$upsertPMPartsU = props.upsertPMPartsUrl) !== null && _props$upsertPMPartsU !== void 0 ? _props$upsertPMPartsU : "",
                parentModuleDocumentId: props.parentModuleDocumentId,
                callApIStatus: periodicMaintainanceApiCall,
                isSaveButton: isSaveButton,
                isDisabled: props.isDisabled,
                SystemName: (_props$SystemName = props.SystemName) !== null && _props$SystemName !== void 0 ? _props$SystemName : "",
                alternatePartConfigState: alternatePartConfigState,
                showRepeatItems: function (repeatItems, savedItems) {
                    showRepeatItems(repeatItems, savedItems);
                }
            })) : null;
        })) : (item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.StandardJobs && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut33 = item.SectionAttributes[0]) !== null && _item$SectionAttribut33 !== void 0 && _item$SectionAttribut33.HIDE) ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            padding: "8px 16px 8px 16px"
        }, item === null || item === void 0 || (_item$SectionAttribut34 = item.SectionAttributes) === null || _item$SectionAttribut34 === void 0 ? void 0 : _item$SectionAttribut34.map(function (elem, accordianIndex) {
            var _props$SystemName2;
            return !elem.HIDE ? /*#__PURE__*/ React.createElement(CustomeAccordianWithButton, {
                key: accordianIndex,
                isMandatory: (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && Module === isModuleConfig.Bajaj,
                title: item === null || item === void 0 ? void 0 : item.DisplayName,
                id: item === null || item === void 0 ? void 0 : item.DisplayName,
                KeyForId: "TASK_DETAILS_" + (item === null || item === void 0 ? void 0 : item.Key),
                switchButtonsEnabled: allswitchEnabled || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
                isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
                handleClick: function () {
                    getStandaredJobApiCall();
                    checkPerformAll();
                },
                isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
                handleAccordianClick: function (value) { return handleAccordianClick(value, EModuleSection.StandardJobs); },
                selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || getTaskDetailsToggleValue.standardJobsToggle || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
                listLength: getModuleHeaderCount === null || getModuleHeaderCount === void 0 ? void 0 : getModuleHeaderCount.StandardParts,
                countVisible: true
            }, /*#__PURE__*/ React.createElement(StandaredJobsComponent, {
                parentModuleName: props.parentModuleName,
                SaveStandaredJobUrl: props.SaveStandaredJobUrl,
                getSavedStandaredJobUrl: props.getSavedStandaredJobUrl,
                callApIStatus: callApi,
                isSaveButton: isSaveButton,
                isDisabled: props.isDisabled,
                alternatePartConfigState: alternatePartConfigState,
                SystemName: (_props$SystemName2 = props.SystemName) !== null && _props$SystemName2 !== void 0 ? _props$SystemName2 : "",
                showRepeatItems: function (repeatItems, savedItems) {
                    showRepeatItems(repeatItems, savedItems);
                }
            })) : null;
        })) : !props.isFromAppointmentTask && (item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.Precheck && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut35 = item.SectionAttributes[0]) !== null && _item$SectionAttribut35 !== void 0 && _item$SectionAttribut35.HIDE) ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            padding: "8px 16px 8px 16px"
        }, item === null || item === void 0 || (_item$SectionAttribut36 = item.SectionAttributes) === null || _item$SectionAttribut36 === void 0 ? void 0 : _item$SectionAttribut36.map(function (elem, accordianIndex) {
            var _props$SystemName3;
            return !elem.HIDE ? /*#__PURE__*/ React.createElement(CustomeAccordianWithButton, {
                isMandatory: (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && Module === isModuleConfig.Bajaj,
                key: accordianIndex,
                title: item === null || item === void 0 ? void 0 : item.DisplayName,
                id: item === null || item === void 0 ? void 0 : item.DisplayName,
                KeyForId: "TASK_DETAILS_" + (item === null || item === void 0 ? void 0 : item.Key),
                switchButtonsEnabled: allswitchEnabled || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
                isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
                handleClick: function () {
                    setPrecheckApiCall(true);
                },
                isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
                handleAccordianClick: function (value) { return handleAccordianClick(value, EModuleSection.Precheck); },
                selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || getTaskDetailsToggleValue.preCheckToggle || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
                countVisible: false
            }, /*#__PURE__*/ React.createElement(PreCheckCommonComponent, {
                parentModuleName: props.parentModuleName,
                parentModuleDocumentId: props.parentModuleDocumentId,
                apiRequestParam: props.apiRequestParam,
                getSavedFuelPercentageUrl: "",
                upsertFuelPercentageUrl: "",
                installBaseId: "",
                callApIStatus: precheckApiCall,
                apiRequestPayload: props.apiRequestPayload,
                SystemName: (_props$SystemName3 = props.SystemName) !== null && _props$SystemName3 !== void 0 ? _props$SystemName3 : "",
                isSaveButton: isSaveButton,
                isFromTaskDetails: true,
                isDisabled: props.isDisabled,
                fuelIdicatorDynamicListData: __spreadArray([], fuelIdicatorDynamicListTaskDetails, true),
                precheckQuestionsAnswerData: precheckQuestionsAnswer,
                setFuelCallBack: function (data) {
                    setFuelIndicatorDynamicListTaskDetails(__spreadArray([], data, true));
                }
            })) : null;
        })) : !props.isFromAppointmentTask && (item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.RoadTest && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut37 = item.SectionAttributes[0]) !== null && _item$SectionAttribut37 !== void 0 && _item$SectionAttribut37.HIDE) ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            padding: "8px 16px 8px 16px"
        }, item === null || item === void 0 || (_item$SectionAttribut38 = item.SectionAttributes) === null || _item$SectionAttribut38 === void 0 ? void 0 : _item$SectionAttribut38.map(function (elem, accordianIndex) {
            return !elem.HIDE ? /*#__PURE__*/ React.createElement(CustomeAccordianWithButton, {
                key: accordianIndex,
                isMandatory: (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && Module === isModuleConfig.Bajaj,
                title: item === null || item === void 0 ? void 0 : item.DisplayName,
                id: item === null || item === void 0 ? void 0 : item.DisplayName,
                KeyForId: "TASK_DETAILS_" + (item === null || item === void 0 ? void 0 : item.Key),
                switchButtonsEnabled: allswitchEnabled || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
                isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
                handleClick: function () {
                    setRoadTestApiCall(true);
                },
                isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
                handleAccordianClick: function (value) { return handleAccordianClick(value, EModuleSection.RoadTest); },
                selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || getTaskDetailsToggleValue.roadTestToggle || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
                countVisible: false
            }, /*#__PURE__*/ React.createElement(RoadTestComponent, {
                parentModuleName: props.parentModuleName,
                parentModuleDocumentId: parentModuleDocumentId,
                callApIStatus: roadTestApiCall,
                getCustomerComplaintListUrl: props.getCustomerComplaintListUrl,
                saveTranslateToJobItemUrl: props.saveTranslateToJobItemUrl,
                apiRequestParam: props.apiRequestParam,
                apiRequestPayload: props.apiRequestPayload,
                isSaveButton: isSaveButton,
                isDisabled: props.isDisabled,
                SystemName: props.SystemName
            })) : null;
        })) : !props.isFromAppointmentTask && (item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.AdditionalJobs && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut39 = item.SectionAttributes[0]) !== null && _item$SectionAttribut39 !== void 0 && _item$SectionAttribut39.HIDE) ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            padding: "8px 16px 8px 16px"
        }, item === null || item === void 0 || (_item$SectionAttribut40 = item.SectionAttributes) === null || _item$SectionAttribut40 === void 0 ? void 0 : _item$SectionAttribut40.map(function (elem, accordianIndex) {
            return !elem.HIDE ? /*#__PURE__*/ React.createElement(CustomeAccordianWithButton, {
                key: accordianIndex,
                isMandatory: (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && Module === isModuleConfig.Bajaj,
                title: item === null || item === void 0 ? void 0 : item.DisplayName,
                id: item === null || item === void 0 ? void 0 : item.DisplayName,
                KeyForId: "TASK_DETAILS_" + (item === null || item === void 0 ? void 0 : item.Key),
                switchButtonsEnabled: allswitchEnabled || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue) || additionalJobAdded,
                isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
                handleClick: function () {
                    getAdditionalJobApiCall();
                },
                isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
                handleAccordianClick: function (value) { return handleAccordianClick(value, EModuleSection.AdditionalJobs); },
                selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || (getTaskDetailsToggleValue === null || getTaskDetailsToggleValue === void 0 ? void 0 : getTaskDetailsToggleValue.additionalJobsToggle) || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (jobCount === null || jobCount === void 0 ? void 0 : jobCount.AdditionalParts) > 0,
                listLength: getModuleHeaderCount === null || getModuleHeaderCount === void 0 ? void 0 : getModuleHeaderCount.AdditionalParts,
                countVisible: true
            }, /*#__PURE__*/ React.createElement(AdditionalJobsComponent, {
                parentModuleName: props.parentModuleName,
                getSavedAddiionalJobUrl: props.getSavedAddiionalJobUrl,
                saveAdditionalJobsUrl: props.saveAdditionalJobsUrl,
                callApIStatus: addiotionalJobApiCall,
                isSaveButton: isSaveButton,
                isDisabled: props.isDisabled,
                additionalJobCallback: getAdditonalJobCallbackButtonDisable,
                alternatePartConfigState: alternatePartConfigState,
                showRepeatItems: function (repeatItems, savedItems) {
                    showRepeatItems(repeatItems, savedItems);
                },
                SystemName: props.SystemName
            })) : null;
        })) : !props.isFromAppointmentTask && (item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.AdvisorSuggestions && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut41 = item.SectionAttributes[0]) !== null && _item$SectionAttribut41 !== void 0 && _item$SectionAttribut41.HIDE) ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            padding: "8px 16px 8px 16px"
        }, item === null || item === void 0 || (_item$SectionAttribut42 = item.SectionAttributes) === null || _item$SectionAttribut42 === void 0 ? void 0 : _item$SectionAttribut42.map(function (elem, accordianIndex) {
            var _ModuleDetailsGetById48;
            return !elem.HIDE ? /*#__PURE__*/ React.createElement(CustomeAccordianWithButton, {
                key: accordianIndex,
                isMandatory: (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && Module === isModuleConfig.Bajaj,
                title: item === null || item === void 0 ? void 0 : item.DisplayName,
                id: item === null || item === void 0 ? void 0 : item.DisplayName,
                KeyForId: "TASK_DETAILS_" + (item === null || item === void 0 ? void 0 : item.Key),
                switchButtonsEnabled: allswitchEnabled || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
                isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
                handleClick: function () { },
                isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
                handleAccordianClick: function (value) { return handleAccordianClick(value, EModuleSection.AdvisorSuggestions); },
                selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
                listLength: (getSavedTaskDetailsCount === null || getSavedTaskDetailsCount === void 0 ? void 0 : getSavedTaskDetailsCount.advisorSuggestionsCount) || 0,
                countVisible: true
            }, /*#__PURE__*/ React.createElement(AdvisorSuggestions, {
                isDisabled: props.isDisabled,
                documentId: props.parentModuleDocumentId,
                installBaseId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById48 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById48 === void 0 ? void 0 : _ModuleDetailsGetById48.InstallBaseId,
                documentType: props.parentModuleName
            })) : null;
        })) : !props.isFromAppointmentTask && (item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.FutureAdvise && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut43 = item.SectionAttributes[0]) !== null && _item$SectionAttribut43 !== void 0 && _item$SectionAttribut43.HIDE) ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            padding: "8px 16px 8px 16px"
        }, item === null || item === void 0 || (_item$SectionAttribut44 = item.SectionAttributes) === null || _item$SectionAttribut44 === void 0 ? void 0 : _item$SectionAttribut44.map(function (elem, accordianIndex) {
            return !elem.HIDE ? /*#__PURE__*/ React.createElement(CustomeAccordianWithButton, {
                key: accordianIndex,
                isMandatory: (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && Module === isModuleConfig.Bajaj,
                title: item === null || item === void 0 ? void 0 : item.DisplayName,
                id: item === null || item === void 0 ? void 0 : item.DisplayName,
                KeyForId: "TASK_DETAILS_" + (item === null || item === void 0 ? void 0 : item.Key),
                switchButtonsEnabled: allswitchEnabled || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
                isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
                handleClick: function () {
                    // Handle suggestions click
                },
                isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
                handleAccordianClick: function (value) { return handleAccordianClick(value, EModuleSection.FutureAdvise); },
                selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
                listLength: (getSavedTaskDetailsCount === null || getSavedTaskDetailsCount === void 0 ? void 0 : getSavedTaskDetailsCount.futureAdviseCount) || 0,
                countVisible: true
            }, /*#__PURE__*/ React.createElement(FutureAdviseGrid, {
                isDisabled: props.isDisabled,
                documentId: props.parentModuleDocumentId,
                documentData: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 ? void 0 : ModuleDetailsGetById.data,
                documentType: props.parentModuleName
            })) : null;
        })) : null;
    }) : /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        height: "100%",
        paddingTop: 25,
        justifyContent: "center",
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h2"
    }, t("No Data Found"), "..!!"))) : /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column"
    }, skeletonArray.map(function () { /*#__PURE__*/ return React.createElement(MuiStack, {
        direction: "column",
        spacing: 1,
        style: {
            width: isDesktop ? "65vw" : "100%",
            height: "9vh",
            padding: "8px 8px 8px 8px"
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)); })), isSaveButton && (ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 ? void 0 : ModuleDetailsGetById.data) && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 12,
        md: 12,
        sm: 12,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: "column",
        justifyContent: "flex-end",
        paddingBottom: "10px",
        position: 'fixed',
        bottom: 0,
        right: 0,
        width: '100%',
        bgcolor: systemColor.backgroundColor,
        zIndex: 9,
        borderTop: '1px solid #DEE4EB',
        paddingY: 1.5,
        paddingRight: 2
    }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        loading: loader.isLoaderOpen,
        size: "medium"
        // name={props.parentModuleName === EParentModuleName.Appointment ? t("Confirm") : t("Generate estimate")}
        ,
        name: handleButtonNames(),
        id: "finishInspectionBtn",
        disabled: DisableTaskDetailButtons(),
        variant: "contained",
        onClick: handleClickButtons,
        style: {
            alignSelf: "flex-end"
        }
    }))))) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
        xs: 12,
        sm: 12,
        md: 11.6,
        lg: 11.6,
        padding: "8px 8px 8px 8px",
        direction: "column",
        sx: {
            paddingTop: Module === isModuleConfig.Bajaj ? "0px" : "42px"
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        spacing: 1,
        style: {
            width: isDesktop ? "63vw" : "100%",
            height: "9vh",
            padding: "16px 16px 8px 16px"
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        spacing: 1,
        style: {
            width: isDesktop ? "63vw" : "100%",
            height: "9vh",
            padding: "16px 16px 8px 16px"
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        spacing: 1,
        style: {
            width: isDesktop ? "63vw" : "100%",
            height: "9vh",
            padding: "16px 16px 8px 16px"
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        spacing: 1,
        style: {
            width: isDesktop ? "63vw" : "100%",
            height: "8vh",
            padding: "16px 16px 8px 16px"
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null))))), isDesktop ? /*#__PURE__*/ React.createElement(Grid, {
        xs: 0,
        sm: 0,
        md: 0.1,
        lg: 0.1,
        borderLeft: "1px solid #DEE4EB",
        flexGrow: 1,
        minHeight: "60vh",
        sx: {
            flexGrow: "1 !important"
        }
    }) : /*#__PURE__*/ React.createElement(React.Fragment, null))), /*#__PURE__*/ React.createElement(UnsavedChangesPopup, {
        isOpen: openPopup,
        onClosePopup: function (value) { return setOpenPopup(value); },
        onClickNoBtn: onClickNoBtn,
        onClickYesBtn: onClickYesBtn
    }), /*#__PURE__*/ React.createElement(MuiPopup, {
        variant: "h1",
        openPopup: openAptcreatePopup,
        onClose: handleCancelPopup,
        closeIcon: true,
        subTitleVariant: "h4",
        subTitleStyle: {
            marginTop: "10px",
            color: "#8593A3"
        },
        backdropEnable: true,
        padding: "15px 0px 0px 15px",
        containerStyle: {
            width: lgMode ? "500px" : "calc(90vw)",
            paddingTop: 0,
            paddingX: "16px"
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        sm: 12,
        md: 12,
        xs: 12,
        lg: 12
    }, /*#__PURE__*/ React.createElement(MyImg, {
        src: SuccessIconNew,
        alt: "settingIcon"
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: "column",
        marginTop: 2
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h1"
    }, t("APPT_CONFIRMATION_MSG")), /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: "row",
        marginTop: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: "#6A7682"
    }, "Appointment: ".concat((_documentDetailsGetBy3 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy4 = documentDetailsGetById.data) === null || _documentDetailsGetBy4 === void 0 ? void 0 : _documentDetailsGetBy4.Code) !== null && _documentDetailsGetBy3 !== void 0 ? _documentDetailsGetBy3 : "-")), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: "black",
        sx: {
            marginLeft: 0
        }
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        bgcolor: "#F5F7FA",
        padding: 2,
        marginTop: 2,
        borderRadius: 3
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        justifyContent: "space-between",
        spacing: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3"
    }, "".concat(t("Scheduled Date"))), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3"
    }, documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy5 = documentDetailsGetById.data) !== null && _documentDetailsGetBy5 !== void 0 && _documentDetailsGetBy5.ScheduledDate ? dateFormate(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy6 = documentDetailsGetById.data) === null || _documentDetailsGetBy6 === void 0 ? void 0 : _documentDetailsGetBy6.ScheduledDate) : "-")), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        justifyContent: "space-between",
        spacing: 1,
        paddingTop: 2
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3"
    }, t("Scheduled Time")), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3"
    }, documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy7 = documentDetailsGetById.data) !== null && _documentDetailsGetBy7 !== void 0 && _documentDetailsGetBy7.SlotStartTime ? getTime(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy8 = documentDetailsGetById.data) === null || _documentDetailsGetBy8 === void 0 ? void 0 : _documentDetailsGetBy8.SlotStartTime) : "-"))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        spacing: 1.5,
        marginTop: 4
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        variant: "contained",
        size: "large",
        color: "primary",
        style: {
            borderColor: "#DEE4EB",
            width: "100%"
        },
        name: t("Go to homepage"),
        onClick: goToHomePage
    })))), /*#__PURE__*/ React.createElement(MuiPopup, {
        variant: "h1",
        openPopup: openPreviousDeclinePopup,
        closeIcon: true,
        backdropEnable: true,
        onClose: onClosePreviouslyDeclinedPopup
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: "column",
        paddingX: 0
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        gap: 1,
        flexDirection: 'column',
        paddingBottom: 2,
        spacing: 0
    }, (previousJobCards === null || previousJobCards === void 0 || (_previousJobCards$dat2 = previousJobCards.data) === null || _previousJobCards$dat2 === void 0 ? void 0 : _previousJobCards$dat2.length) < 1 && /*#__PURE__*/ React.createElement("img", {
        src: WarningTriangle,
        alt: "closeIcon",
        height: '48px',
        width: '48px'
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h1"
    }, t("Previously declined jobs")), /*#__PURE__*/ React.createElement(MuiStack, {
        margin: -3,
        marginTop: 1,
        marginBottom: (previousJobCards === null || previousJobCards === void 0 ? void 0 : previousJobCards.length) > 1 ? 1 : 0
    }, /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            height: '1px',
            width: '100%',
            backgroundColor: systemColor.grey
        }
    }))), /*#__PURE__*/ React.createElement(MuiStack, {
        paddingTop: 0,
        minWidth: '100%',
        paddingX: 0,
        marginTop: 1
    }, /*#__PURE__*/ React.createElement(PreviousDeclinedJob, {
        ModuleSectionByChannel: updatedModuleSectionByChannel,
        closePopup: onClosePreviouslyDeclinedPopup,
        ModuleDetailsGetById: ModuleDetailsGetById,
        previousJobCards: previousJobCards,
        ModuleName: props === null || props === void 0 ? void 0 : props.parentModuleName,
        disabledPreviousDeclined: props.isDisabled,
        getSavedPeriodicPartsUrl: props.getSavedPeriodicPartsUrl,
        getSavedStandaredJobUrl: props.getSavedStandaredJobUrl
    })))), finishPopup && /*#__PURE__*/ React.createElement(MuiPopup, {
        variant: "h1",
        openPopup: finishPopup,
        closeIcon: true,
        backdropEnable: true,
        onClose: function () {
            setFinishPopup(false);
        },
        padding: "15px 0px 0px 15px"
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: "column"
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h1"
    }, t("Do you want to generate estimation?")), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        color: "#6A7682",
        marginTop: 2
    }, t("The total cost description will be generated of availed services")), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        spacing: 3,
        marginTop: 4
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "no-btn",
        size: "medium",
        fullWidth: true,
        name: t("No"),
        variant: "outlined",
        style: {
            border: "1px solid #DEE4EB",
            color: "#6A7682"
        },
        onClick: handleVIFinishNoButton
    }), /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        id: "yes-btn",
        loading: loader.isLoaderOpen,
        size: "medium",
        fullWidth: true,
        name: t("Yes"),
        variant: "contained",
        style: {
            border: "none",
            color: "#fff"
        },
        onClick: handleVIFinishYesButton
    })))), /*#__PURE__*/ React.createElement(MuiPopup, {
        openPopup: showRepeatAlertsPopup,
        onClose: function () {
            setShowRepeatAlertsPopup(false);
        },
        closeIcon: true,
        backdropEnable: true,
        padding: "15px 0px 0px 15px",
        containerStyle: {
            width: lgMode ? "500px" : "calc(90vw)",
            paddingTop: 0,
            paddingX: "16px"
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 2
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 1,
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement("img", {
        src: WarningTriangle
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 0.5
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h1",
        fontWeight: "bold"
    }, "Repeated Jobs"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        color: "textSecondary"
    }, "The following jobs were used in the previous job card"))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 2
    }, repeatJobItems.map(function (item, index) {
        var _item$SystemName;
        return /*#__PURE__*/ React.createElement(Grid, {
            key: index,
            container: true,
            rowSpacing: 1,
            bgcolor: '#F4F7FA',
            padding: 1,
            border: 1,
            borderRadius: 2,
            borderColor: "grey.300"
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 10
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            direction: 'column',
            spacing: 0.5
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h3",
            component: "div"
        }, item.ChildName), /*#__PURE__*/ React.createElement(Typography, {
            variant: "h3",
            color: "textSecondary"
        }, "#".concat(item.ChildCode)))), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 2,
            container: true,
            justifyContent: "flex-start"
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            sx: {
                backgroundColor: "#EEF6FF",
                padding: "3px 8px",
                borderRadius: "15px",
                border: '1px solid #AFD5FF',
                justifyContent: 'center',
                placeItems: 'center',
                placeSelf: 'center'
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                color: systemColor.primary
            },
            variant: "h5"
        }, (_item$SystemName = item.SystemName) === null || _item$SystemName === void 0 ? void 0 : _item$SystemName.substring(0, 1)))));
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        justifyContent: 'center'
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        variant: "contained",
        fullWidth: true,
        name: "Ok",
        onClick: function () {
            setShowRepeatAlertsPopup(false);
        }
    })))));
};
export default TaskDetailsComponent;
